import React, { useState, useEffect } from "react"
import ReactSelect from 'react-select'
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Form,
  CustomInput,
  FormGroup,
  Input,
  Label,
  Collapse,
  Modal,
  ModalBody,
  Alert
} from "reactstrap"
// import BootstrapTable from 'react-bootstrap-table-next'
// import cellEditFactory from 'react-bootstrap-table2-editor'
// import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
// import axios from "axios"
import { xml2json, json2xml } from 'xml-js'
import useForm from 'lib/useForm'
import settings from '../../settings'
import rotas from '../../services/rotas'
import Loading from 'lib/loading'
import './style.css'
import rest from 'lib/rest'
import { toDecimal, toBRL } from 'lib/funcoesNumericas'
import converteCFOP from './../../lib/cfop'
import useToggle from "lib/useToggle"
import FormCadastroProduto from '../Cadastros/Produtos/FormCadastroProdutos';
import moment from "moment"
import { setICMS, getICMS, valorSTxmlToValorST, CSTxmlToCST, aliquotaXMLtoAliquota, valorFCPSTxmlToValorFCPST } from './UtilNfe'
import Swal from "sweetalert2"
import NumberFormat from "react-number-format"
import DateTime from 'react-datetime';
import NfeCPag from "./NfeCPag"
import Cobranca from "./Cobranca"
import TableNfe from "./DataTable/TableNfe"

var idxGrid = 0;
var idxLote = 0;

const EntradaNFe = () => {

  const colunas = [{
      dataField: 'idx',
      text: 'ID',
      editable: false,
      width: 30,
      formatter: (cellContent, row) => {
        //console.log(row);
        return (row.idx ? row.idx + 1 : '1')
      }
    },{
      dataField: 'uso_consumo',
      text: 'USO/CONS',
      checkbox: true,
      width: 70,
      formatter: (cellContent, row) => {
        return (row.det.prod.uso_consumo == 'S' ? true : false)
      }
    },
    {
      dataField: 'cEAN',
      text: 'COD. BARRAS',
      width: 105,
      align: 'center',
      editable: true,
      editValue: (row) => row.det.prod.cEAN._text,
      formatter: (cellContent, row) => {
        const status = statusCodBarras[row.idx];
        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
            <span>{row.det.prod.cEAN._text}</span>
            {status === 'loading' && (
              <i className="fas fa-circle-notch fa-spin" style={{ color: '#2196F3', fontSize: 11 }} title="Buscando produto..."></i>
            )}
            {status === 'found' && (
              <i className="fas fa-check-circle" style={{ color: '#4CAF50', fontSize: 11 }} title="Produto encontrado"></i>
            )}
            {status === 'notFound' && (
              <i className="fas fa-exclamation-circle" style={{ color: '#f44336', fontSize: 11 }} title="Produto não encontrado"></i>
            )}
          </div>
        )
      }
    },
    {
      dataField: 'produto_id_original',
      text: 'COD. PRODUTO',
      editable: false,
      width: 100,
      formatter: (cellContent, row) => {
        if (row.det.prod.produto_id_original._text === '') {

          if (permiteCadastroProduto) {
            let produto = {};

            if (row.det.prod.cEAN._text === 'SEM GTIN') {
              produto.cod_barras = ''
            } else {
              produto.cod_barras = row.det.prod.cEAN._text;
            }

            produto.produto = row.det.prod.xProd._text;
            produto.visible = true;
            //produto.filial_id = '101';

            // setDadosProduto(produto);
            return (
              <Button
                onClick={() => {
                  setModal(produto);
                }}
                className="btnCadastrar m-0"
              >
                Cadastrar
              </Button>
            );
          } else {
            return (
              <span>
                Não Cadastrado
              </span>
            );
          }
        } else {
          return (row.det.prod.produto_id_original._text)
        }
      }
    },
    {
      dataField: 'xProd',
      text: 'PRODUTO',
      editable: false,
      width: 250,
      align: 'left',
      formatter: (cellContent, row) => {
        return (row.det.prod.xProd._text)
      }
    },
    {
      dataField: 'qCom',
      text: 'QTD',
      editable: false,
      width: 50,
      formatter: (cellContent, row) => {
        //console.log(row.det.prod.qCom._text);
        return (parseInt(row.det.prod.qCom._text))
      }
    },
    {
      dataField: 'hospitalar',
      text: 'HOSP.',
      width: 50,
      editable: true,
      formatter: (cellContent, row) => {
        return (Math.round(toDecimal(row.det.prod.Hospitalar._text)))
      }
    },
    {
      dataField: 'vPMC',
      text: 'PMC',
      editable: false,
      width: 80,
      formatter: (cellContent, row) => {
        return toBRL(row.det.prod.med ? row.det.prod.med.vPMC._text : 0)
      }
    },
    {
      dataField: 'vUnCom',
      text: 'PR. COMPRA',
      editable: false,
      width: 80,
      formatter: (cellContent, row) => {
        const vUnCom   = parseFloat(row.det.prod.vUnCom._text || 0);
        const vOutro   = parseFloat(row.det.prod.vOutro ? row.det.prod.vOutro._text : 0);
        const qCom     = parseFloat(row.det.prod.qCom._text || 1);
        const despUnit = Math.round((vOutro / qCom) * 100) / 100;
        return toBRL(vUnCom + despUnit);
      }
    }, {
      dataField: 'vDesc',
      text: 'DESCONTO',
      editable: false,
      width: 80,
      formatter: (cellContent, row) => {
        return toBRL(parseFloat(row.det.prod.vDesc ? row.det.prod.vDesc._text : 0) / parseFloat(row.det.prod.qCom._text || 1))
      }
    },
    {
      dataField: 'valor_total',
      text: 'TOTAL',
      editable: false,
      width: 80,
      formatter: (cellContent, row) => {
        const vProd  = parseFloat(row.det.prod.vProd._text || 0);
        const vDesc  = parseFloat(row.det.prod.vDesc ? row.det.prod.vDesc._text : 0);
        const vOutro = parseFloat(row.det.prod.vOutro ? row.det.prod.vOutro._text : 0);
        return toBRL(vProd - vDesc + vOutro);
      }
    },
    {
      dataField: 'valor_unitario',
      text: 'VL. UNIT.',
      editable: false,
      width: 80,
      align: 'center',
      formatter: (cellContent, row) => {
        const vProd    = parseFloat(row.det.prod.vProd._text || 0);
        const vDesc    = parseFloat(row.det.prod.vDesc ? row.det.prod.vDesc._text : 0);
        const vOutro   = parseFloat(row.det.prod.vOutro ? row.det.prod.vOutro._text : 0);
        const qCom     = parseFloat(row.det.prod.qCom._text || 1);
        const despUnit = Math.round((vOutro / qCom) * 100) / 100;
        return toBRL((vProd - vDesc) / qCom + despUnit);
      }
    },
    {
      dataField: 'comparacao_preco',
      text: '',
      editable: false,
      width: 30,
      align: 'center',
      formatter: (cellContent, row) => {
        const ultCompra = parseFloat(row.det.prod.valor_ult_compra ? row.det.prod.valor_ult_compra._text : 0);
        const vProd    = parseFloat(row.det.prod.vProd._text || 0);
        const vDesc    = parseFloat(row.det.prod.vDesc ? row.det.prod.vDesc._text : 0);
        const vOutro   = parseFloat(row.det.prod.vOutro ? row.det.prod.vOutro._text : 0);
        const qCom     = parseFloat(row.det.prod.qCom._text || 1);
        const despUnit = Math.round((vOutro / qCom) * 100) / 100;
        const valorAtual = (vProd - vDesc) / qCom + despUnit;
        if (ultCompra === 0) return <span style={{ color: '#aaa' }}>—</span>;
        if (valorAtual > ultCompra) return <i className="fa fa-arrow-up" style={{ color: '#e74c3c', fontSize: '14px' }} title="Mais caro que a última compra"></i>;
        if (valorAtual < ultCompra) return <i className="fa fa-arrow-down" style={{ color: '#27ae60', fontSize: '14px' }} title="Mais barato que a última compra"></i>;
        return <i className="fa fa-minus" style={{ color: '#f39c12', fontSize: '14px' }} title="Mesmo preço da última compra"></i>;
      }
    },
    {
      dataField: 'valor_ult_compra',
      text: 'ULT. COMPRA',
      editable: false,
      width: 85,
      align: 'center',
      formatter: (cellContent, row) => {
        return toBRL(row.det.prod.valor_ult_compra ? row.det.prod.valor_ult_compra._text : '0')
      }
    },
    {
      dataField: 'prod_prvenda',
      text: 'DIGIFARMA',
      editable: false,
      width: 80,
      formatter: (cellContent, row) => {
        return toBRL(row.det.prod.prod_prvenda._text)
      }
    },
    {
      dataField: 'margem_lucro',
      text: 'MARKUP',
      width: 80,
      editable: true,
      currency: true,
      editValue: (row) => parseFloat(row.det.prod.margem_lucro._text || 0),
      formatter: (cellContent, row) => {
        return `${toDecimal(row.det.prod.margem_lucro._text).replace('.', ',')} %`
      },
      disabled: (row) => parseFloat(row.det.prod.margem_lucro._text) == 0,
      tooltip: (row) => parseFloat(row.det.prod.margem_lucro._text) == 0
        ? 'Markup bloqueado: produto sem margem de lucro cadastrada'
        : '',
      style: (cell, row, rowIndex, colIndex) => {
        if (parseFloat(row.det.prod.margem_lucro._text) == 0) {
          return {
            cursor: 'not-allowed'
          };
        }
      }
    },
    {
      dataField: 'prVendaCorrigido',
      text: 'ATUALIZADO',
      width: 90,
      editable: true,
      currency: true,
      editValue: (row) => toDecimal(row.det.prod.prVendaCorrigido._text),
      formatter: (cellContent, row) => {
        return toBRL(row.det.prod.prVendaCorrigido._text)
      },
      style: (cell, row) => {
        const prAtualizado = parseFloat(row.det.prod.prVendaCorrigido._text) || 0;
        const prMatriz     = parseFloat(row.det.prod.preco_matriz._text)     || 0;
        const cadastrado   = row.det.prod.produto_id_original._text !== '';
        if (!cadastrado) return {};
        if (prAtualizado === 0)                          return { backgroundColor: '#FEBC98' };
        if (cadastrado && prMatriz > prAtualizado)       return { backgroundColor: '#C5EA69' };
        if (cadastrado && prMatriz < prAtualizado)       return { backgroundColor: '#ff8080' };
      }
    },
    {
      dataField: 'prod_prpromocao',
      text: 'PROMOÇÃO',
      width: 90,
      editable: true,
      currency: true,
      editValue: (row) => toDecimal(row.det.prod.prod_prpromocao ? row.det.prod.prod_prpromocao._text : '0'),
      formatter: (cellContent, row) => {
        return toBRL(row.det.prod.prod_prpromocao ? row.det.prod.prod_prpromocao._text : '0')
      }
    },
    {
      dataField: 'prod_prcrediario',
      text: 'PR. CREDIÁRIO',
      width: 90,
      editable: true,
      currency: true,
      editValue: (row) => toDecimal(row.det.prod.prod_prcrediario ? row.det.prod.prod_prcrediario._text : '0'),
      formatter: (cellContent, row) => {
        return toBRL(row.det.prod.prod_prcrediario ? row.det.prod.prod_prcrediario._text : '0')
      }
    },
    {
      dataField: 'preco_matriz',
      text: 'MATRIZ',
      editable: false,
      width: 80,
      formatter: (cellContent, row) => {
        return toBRL(row.det.prod.preco_matriz._text)
      },
      // style: (cell, row, rowIndex, colIndex) => {
      //   if (row.det.prod.preco_matriz._text < row.det.prod.prVendaCorrigido._text) {
      //     return {
      //       backgroundColor: '#ff8080'
      //     };
      //   }

      //   if (row.det.prod.preco_matriz._text > row.det.prod.prVendaCorrigido._text) {
      //     return {
      //       backgroundColor: '#C5EA69'
      //     };
      //   }
      // }
    },
    {
      dataField: 'NCM',
      text: 'NCM',
      editable: false,
      width: 80,
      formatter: (cellContent, row) => {
        return (row.det.prod.NCM._text)
      }
    },
    {
      dataField: 'CFOP',
      text: 'CFOP',
      width: 80,
      editable: true,
      formatter: (cellContent, row) => {
        return (row.det.prod.CFOP._text)
      }
    },
    {
      dataField: 'cst',
      text: 'CST',
      width: 80,
      editable: true,
      formatter: (cellContent, row) => {
        //return('070');
        return (CSTxmlToCST(row.det.imposto))
      }
    },
    {
      dataField: 'aliquotaIcms',
      text: 'Aliq. ICMS',
      width: 80,
      editable: true,
      currency: true,
      editValue: (row) => toDecimal(aliquotaXMLtoAliquota(row.det.imposto)),
      formatter: (cellContent, row) => {
        return `${parseFloat(aliquotaXMLtoAliquota(row.det.imposto))}%`
      }
    },
    {
      dataField: 'valorST',
      text: 'Valor ST',
      width: 80,
      editable: true,
      editValue: (row) => valorSTxmlToValorST(row.det.imposto),
      formatter: (cellContent, row) => {
        return toBRL(valorSTxmlToValorST(row.det.imposto))
      }
    },
    {
      dataField: 'valorFCPST',
      text: 'FCP ST',
      width: 80,
      editable: false,
      currency: true,
      formatter: (cellContent, row) => {
        return toBRL(valorFCPSTxmlToValorFCPST(row.det.imposto))
      }
    }
  ]

  // const colunasLotes = [{
  //   dataField: 'nLote',
  //   text: 'Lote',
  //   width: 80,
  //   formatter: (cellContent, row) => {
  //     // return (row.nLote._text)
  //     return (row.nLote)
  //   },
  //   // style:{width:150}
  // },
  // {
  //   dataField: 'qLote',
  //   text: 'Qtde',
  //   width: 50,
  //   formatter: (cellContent, row) => {
  //     // return (row.nLote._text)
  //     return (row.qLote)
  //   },
  //   //style:{backgroundColor:'#ff0000',color:'#FFFFFF'}
  // },
  // {
  //   dataField: 'dFab',
  //   text: 'Fabricação',
  //   width: 100,
  //   formatter: (cellContent, row) => {
  //     return (row.dFab)
  //   },
  //   //style:{backgroundColor:'#ff0000',color:'#FFFFFF'}
  // },
  // {
  //   dataField: 'dVal',
  //   text: 'Validade',
  //   width: 100,
  //   formatter: (cellContent, row) => {
  //     // return (row.nLote._text)
  //     return (row.dVal)
  //   },
  //   //style:{backgroundColor:'#ff0000',color:'#FFFFFF'}
  // },
  // {
  //   dataField: '',
  //   text: '',
  //   width: 80,
  //   formatter: (cellContent, row) => {
  //     return (
  //       <>
  //         <Button
  //           className="btn-icon btn-neutral"
  //           color="danger"
  //           id=""
  //           size="md"
  //           type="button"
  //           onClick={() => { removeLote(row) }}
  //         >
  //           <i className="fas fa-times" />
  //         </Button>
  //       </>


  //     )
  //   },
  //   style: { width: 150 }
  //   //style:{backgroundColor:'#ff0000',color:'#FFFFFF'}
  // }

  // ]

  let dataLotes = [];

  const data = []
  let notaOK = true;

  let produtosNfe = [];

  let initialForm = {
    dividir_desconto: 'N',
    nao_incluir_st: 'N',
    lancar_duplicatas: 'N',
    dadosNota: {
      ide: {
        nNF: '',
        dhEmi: '',
        mod: '',
        serie: '',
      },
      emit: {
        xNome: ''
      },
      dest: {
        CNPJ: ''
      },
      total: {
        ICMSTot: {
          vBC: '',
          vICMS: '',
          vBCST: '',
          vST: '',
          vProd: '',
          vFrete: '',
          vSeg: '',
          vDesc: '',
          vNF: '',
          vOutro: ''
        }
      }
    },
    produtosNfe: [{
      det: {
        _attributes: {},
        prod: {
          nitem: '',
          cProd: '',
          cEAN: '',
          xProd: '',
          NCM: '',
          CEST: '',
          CFOP: '',
          uCom: '',
          qCom: '',
          vUnCom: '',
          vProd: '',
          cEANTrib: '',
          uTrib: '',
          qTrib: '',
          vUnTrib: '',
          indTot: '',
          xPed: '',
          produto_id_original: '',
          med: {
            vPMC: '',
          },
          hospitalar: '',
          valor_total: '',
          prod_prvenda: '',
          margem_lucro: '',
          tipo_preco: '',
          // prod_prpromocao: '',          
          prVendaCorrigido: '',
          razao_social: '',
          fantasia: '',
          cnpj: ''
        },
        imposto: {
          ICMS: {

          }
        }
      }
    }],
    cobr: []
  }

  const [form] = useForm(initialForm);

  const rowStyle2 = (row, rowIndex) => {
    const style = { cursor: 'default' };

    const prod        = row.det.prod;
    const cadastrado  = prod.produto_id_original._text !== '';
    const prAtualizado = parseFloat(prod.prVendaCorrigido._text) || 0;
    const prMatriz     = parseFloat(prod.preco_matriz._text)     || 0;

    if (cadastrado && prAtualizado === 0) {
      style.backgroundColor = '#FEBC98'; // Pr. Venda = R$ 0,00
    }

    if (prod.prod_ativo._text === 'N') {
      style.backgroundColor = '#ffcc80'; // Produto Inativo (sobrescreve preço)
    }

    if (!cadastrado) {
      style.backgroundColor = '#f44336'; // Produto Não Cadastrado (prioridade máxima)
      style.color = 'white';
    }

    return style;
  };

  const initialSweet = {
    show: false,
    title: '',
    text: '',
    type: 'success'
  }

  const initialNovoLote = {
    nLote: { _text: '' },
    qLote: { _text: '' },
    dFab: { _text: '' },
    dVal: { _text: '' }
  }

  // const { SearchBar } = Search;
  const [loading, setLoading] = useState(true);
  const [xml, setXml] = useState('');
  const [nfe, setNfe] = useState([{}]);
  const [produtosSite, setProdutosSite] = useState([]);
  const [sweetProps, setSweetProps] = useState(initialSweet);
  //const [modal, setModal] = useToggle(false);
  const [modal, setModal] = useState({});
  const [dadosProduto, setDadosProduto] = useState(''); //USADO PARA PASSAR POR PARAMETRO OS DADOS DO PRODUTO QUE AINDA NAO ESTA CADASTRADO PARA E TELA DE CADASTRO
  const [refresh, setRefresh] = useState(0);
  const [fornSendoCadastrado, setFornSendoCadastrado] = useState(false);
  const [idxExpanded, setIdxExpanded] = useState([]);
  const [modalLotes, setModalLotes] = useState(false);
  const [novoLote, setNovoLote] = useState(initialNovoLote)
  const [loadingLotes, setLoadingLotes] = useState(false);
  const [destinatario, setDestinatario] = useState([{ fantasia: '', razao_social: '', cnpj: '', mensagem_dup: 'N' }]);
  const [xmlOriginal, setXmlOriginal] = useState('');
  const [disableBtnLocalizar, setDisableBtnLocalizar] = useState(false);
  const [permiteCadastroProduto, setPermiteCadastroProduto] = useState(false);
  const [editCobIdx, setEditCobIdx] = useState(null);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [chaveNfe, setChaveNfe] = useState('');
  const [processandoNota, setProcessandoNota] = useState(false);
  const [statusCodBarras, setStatusCodBarras] = useState({});
  const [colOrder, setColOrder] = useState(() => {
    try {
      const saved = localStorage.getItem('nfe-col-order');
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });

  //dados lista Estabelecimentos
  const [listaLojas, setListaLojas] = useState([])
  const [cnpjAlerta, setCnpjAlerta] = useState(false)

  // lojas com certificado NFe configurado (para o download por chave)
  const [lojasNfe, setLojasNfe]         = useState([])   // array de opções do select
  const [filialNfe, setFilialNfe]        = useState(null) // opção selecionada { value, label }
  const [lojasNfeLoading, setLojasNfeLoading] = useState(true)

  const [formulario, setfomulario] = useState(initialForm);

  const verificaCpag = () => {
    const url = settings.url + rotas.nfeCpag;

    const retorno = rest.get(url + '?cnpj=' + formulario.dadosNota.emit.CNPJ._text);

    retorno.then(ret => {
      if (ret.success === 'S') {
        if (ret.lista.length == 0) {
          Swal.fire('Atenção',
            'Esta é a primeira nota deste fornecedor, por favor cadastre a referência para o contas a pagar',
            'info');
          setIsOpenModalCpag(true);
        }
      }
    })
  }

  const onChangeChaveNfe = (e) => {
    setChaveNfe(e.target.value);
  }

  const downloadXml = () => {
    if (!filialNfe) {
      Swal.fire('Atenção', 'Selecione a loja antes de baixar a NF-e', 'warning')
      return
    }
    if (!chaveNfe || chaveNfe.replace(/\D/g, '').length !== 44) {
      Swal.fire('Atenção', 'Digite a chave de acesso com 44 dígitos', 'warning')
      return
    }
    setProcessandoNota(true);
    let url = settings.url + rotas.nfeDownload;
    url += '?chave=' + chaveNfe.replace(/\D/g, '') + '&filial_id=' + filialNfe.value;

    const retorno = rest.get(url);
    retorno.then(ret => {
      if (ret.success === 'S') {
        // Remove o overlay ANTES da chamada de status: quando o statusNfe responder
        // o React já terá re-renderizado sem o fundo branco
        setProcessandoNota(false);
        const chaveVerif = chaveNfe.replace(/\D/g, '');
        rest.get(settings.url + rotas.statusNfe + '?chave=' + chaveVerif).then(statusRet => {
          if (statusRet.retorno && statusRet.retorno.length > 0) {
            const s = statusRet.retorno[0];
            if (s.retorno === 'P') {
              Swal.fire('Atenção', 'Esta nota fiscal está pendente de lançamento no Digifarma, por favor aguarde.', 'warning');
              return;
            }
            if (s.retorno === 'S' && s.status_exclusao !== 'S') {
              // Nota já lançada: abre para visualização mas bloqueia o lançamento
              setXml(atob(ret.xml));
              setXmlOriginal(atob(ret.xml));
              setBtDisabled(true);
              Swal.fire('Atenção', 'Esta nota fiscal já foi lançada no sistema!', 'warning');
              return;
            }
            if (s.retorno === 'F') {
              // Nota com falha anterior — avisa mas permite tentar lançar novamente
              const motivo = s.motivo ? `: ${s.motivo}` : '';
              Swal.fire('Atenção', `Esta nota teve uma falha no lançamento anterior${motivo}. Verifique e tente novamente.`, 'warning');
            }
          }
          // Nota não lançada ainda — abre normalmente
          setXml(atob(ret.xml));
          setXmlOriginal(atob(ret.xml));
        }).catch(() => {
          // Se falhar a verificação, abre mesmo assim (não bloqueia o fluxo)
          setXml(atob(ret.xml));
          setXmlOriginal(atob(ret.xml));
        });
      } else {
        setProcessandoNota(false);
        setTimeout(() => {
          Swal.fire('Atenção', ret.msg || 'Erro ao baixar a NF-e', ret.pode_tentar_novamente ? 'info' : 'warning');
        }, 0);
      }
    }).catch(() => {
      setProcessandoNota(false);
      setTimeout(() => {
        Swal.fire('Erro', 'Falha na comunicação ao baixar a NF-e', 'error');
      }, 0);
    });
  }

  const verificaCnpjDestinatario = (lojas, form) => {
    if (!form.dadosNota || !form.dadosNota.dest) return;
    const destCnpj = (form.dadosNota.dest.CNPJ._text || '').replace(/\D/g, '');
    if (!destCnpj) return;
    const match = lojas.some(l => (l.cnpj || '').replace(/\D/g, '') === destCnpj);
    setCnpjAlerta(!match);
    if (!match) setBtDisabled(true);
  }

  const listarLojas = () => {
    const url = settings.url + rotas.lojas;
    const retorno = rest.get(url);
    let oLojas = [];
    retorno.then(ret => {
      if (ret.success === 'S') {
        ret.lista.map(loja => {
          oLojas.push({ id: loja.filial_id, title: loja.fantasia, cnpj: loja.cnpj })
        });
        setListaLojas(oLojas);
        verificaCnpjDestinatario(oLojas, formulario);
      }
    })
  }

  // carrega lojas que têm certificado NFe configurado
  const carregarLojasNfe = () => {
    setLojasNfeLoading(true)
    rest.get(rotas.nfeDfeConfig)
      .then(ret => {
        if (ret.success === 'S') {
          const configuradas = (ret.lista || [])
            .filter(l => l.tem_certificado === 'S')
            .map(l => ({ value: l.filial_id, label: l.fantasia }))
          setLojasNfe(configuradas)
          // se só houver uma, pré-seleciona automaticamente
          if (configuradas.length === 1) setFilialNfe(configuradas[0])
        }
      })
      .catch(() => {})
      .finally(() => setLojasNfeLoading(false))
  }

  useEffect(() => {
    setLoading(false);
    listarLojas();
    carregarLojasNfe();
  }, [])

  useEffect(() => {
    if (xml !== '') {
      listaProdutos();
      // listaDestinatario();
    }
  }, [xml])

  useEffect(() => {
    if (xml !== '') {
      listaNota();
    }
  }, [produtosSite, fornSendoCadastrado])

  useEffect(() => {
    listaDestinatario();
    preparaCobranca();

    if (formulario.dadosNota._attributes) {
      const retorno = statusNota();

      retorno.then(ret => {
        if (ret.retorno.length > 0) {
          if (ret.retorno[0].retorno === 'P') {
            setBtDisabled(true);
            setLoading(false);
            setProcessandoNota(false);
            setTimeout(() => {
              if (!Swal.isVisible()) {
                Swal.fire('Atenção',
                  'Nota Fiscal pendente de lançamento no Digifarma, por favor aguarde',
                  'warning');
              }
            }, 0);
          } else if ((ret.retorno[0].retorno === 'S') && (ret.retorno[0].status_exclusao !== 'S')) {
            setBtDisabled(true);
            setLoading(false);
            setProcessandoNota(false);
            setTimeout(() => {
              if (!Swal.isVisible()) {
                Swal.fire('Atenção',
                  'Nota Fiscal já lançada!',
                  'warning');
              }
            }, 0);
          } else if (ret.retorno[0].retorno === 'F') {
            // Nota com falha anterior — avisa mas permite tentar lançar novamente
            setLoading(false);
            setProcessandoNota(false);
            const motivo = ret.retorno[0].motivo ? `: ${ret.retorno[0].motivo}` : '';
            setTimeout(() => {
              if (!Swal.isVisible()) {
                Swal.fire('Atenção',
                  `Esta nota teve uma falha no lançamento anterior${motivo}. Verifique e tente novamente.`,
                  'warning');
              }
            }, 0);
            if (confereProdutos()) {
              setBtDisabled(false);
            }
            verificaCnpjDestinatario(listaLojas, formulario);
          } else {
            if (confereProdutos()) {
              setBtDisabled(false);
            }
            verificaCnpjDestinatario(listaLojas, formulario);
            setProcessandoNota(false);
          }
        } else {
          if (confereProdutos()) {
            setBtDisabled(false);
          }
          verificaCnpjDestinatario(listaLojas, formulario);
          setProcessandoNota(false);
        }
      }).catch(() => setProcessandoNota(false));
    }
  }, [formulario])

  const [activeTab, setActiveTab] = useState('1');
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  }

  const confereProdutos = () => {
    let resultado = true;
    formulario.produtosNfe.map(produto => {
      if (produto.det.prod.produto_id_original._text === '') {
        resultado = false;
      }
    })
    return (resultado);
  }

  // const fileUpload = (file) => {
  //   console.log(file);
  //   const url = 'http://10.1.1.72/file-upload/upload.php';
  //   //const formData = {files: file}
  //   const formData = new FormData();
  //   formData.append('file',file[0])
  //   const config = {
  //     headers: {
  //       'content-type': 'multipart/form-data'
  //     }
  //   }
  //   let retorno = axios.post(url, formData, config);
  //   retorno.then(ret => {
  //     console.log(ret);

  //   })

  // }

  const [btDisabled, setBtDisabled] = useState(true);
  const [retornoXML, setRetornoXML] = useState('Selecione o arquivo XML');
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenModalCpag, setIsOpenModalCpag] = useState(false);
  const [isOpenModalCobranca, setIsOpenModalCobranca] = useState(false);

  const colunasOrdenadas = colOrder
    ? colOrder
        .map(field => colunas.find(c => c.dataField === field))
        .filter(Boolean)
        .concat(colunas.filter(c => !colOrder.includes(c.dataField)))
    : colunas;

  const handleSetColumn = (newCols) => {
    const order = newCols.map(c => c.dataField);
    setColOrder(order);
    localStorage.setItem('nfe-col-order', JSON.stringify(order));
  };

  const normalizaJxml = (jxml) => {
    if (!jxml.nfeProc && jxml.NFe) {
      return { nfeProc: { NFe: jxml.NFe } };
    }
    return jxml;
  };

  const carregaXML = (file) => {
    const reader = new FileReader();

    setProcessandoNota(true);
    setDisableBtnLocalizar(true);
    setXml('');
    setfomulario(initialForm);
    setLoading(true);

    reader.onload = () => {
      var text = reader.result;

      // Extrai a chave de acesso diretamente do XML (sem depender da cadeia de efeitos)
      const chaveMatch = text.match(/Id=["']?NFe(\d{44})["']?/);
      const chaveXml = chaveMatch ? chaveMatch[1] : '';

      setXml(text);
      setXmlOriginal(text);
      setBtDisabled(true);
      setRetornoXML('Selecione outro arquivo XML...');
      setIsOpen(true);
      setLoading(false);
      // Remove o overlay ANTES da chamada de status: quando o statusNfe responder
      // o React já terá re-renderizado sem o fundo branco
      setProcessandoNota(false);

      // Verificação explícita de status — não depende da cadeia listaProdutos→listaNota
      if (chaveXml) {
        rest.get(settings.url + rotas.statusNfe + '?chave=' + chaveXml).then(statusRet => {
          if (statusRet.retorno && statusRet.retorno.length > 0) {
            const s = statusRet.retorno[0];
            if (s.retorno === 'P') {
              setBtDisabled(true);
              if (!Swal.isVisible()) {
                Swal.fire('Atenção', 'Esta nota fiscal está pendente de lançamento no Digifarma, por favor aguarde.', 'warning');
              }
              return;
            }
            if (s.retorno === 'S' && s.status_exclusao !== 'S') {
              setBtDisabled(true);
              if (!Swal.isVisible()) {
                Swal.fire('Atenção', 'Esta nota fiscal já foi lançada no sistema!', 'warning');
              }
              return;
            }
            if (s.retorno === 'F') {
              // Nota com falha anterior — avisa mas permite tentar lançar novamente
              const motivo = s.motivo ? `: ${s.motivo}` : '';
              if (!Swal.isVisible()) {
                Swal.fire('Atenção', `Esta nota teve uma falha no lançamento anterior${motivo}. Verifique e tente novamente.`, 'warning');
              }
            }
          }
          // Nota não lançada — cadeia de efeitos vai habilitar o botão quando adequado
        }).catch(() => {
          // Falha na verificação não bloqueia o fluxo
        });
      }
    };

    reader.readAsText(file[0]);
  }

  const populaDatalotes = (row) => {
    dataLotes = [];

    if (row.det.prod.rastro) {
      dataLotes.push({
        nLote: row.det.prod.rastro.nLote._text,
        qLote: row.det.prod.rastro.qLote._text,
        dFab: row.det.prod.rastro.dFab._text,
        dVal: row.det.prod.rastro.dVal._text
      })
    }
    dataLotes.push({
      nLote: '',
      qLote: '',
      dFab: '',
      dVal: ''
    })
  }

  const statusNota = () => {
    const chave = formulario.dadosNota._attributes ? formulario.dadosNota._attributes.Id.replace('NFe', '') : '';
    const url = settings.url + rotas.statusNfe;
    let retorno = rest.get(url + '?chave=' + chave);

    return (retorno);
  }

  const toggle = () => {
    setTooltipOpen(!tooltipOpen);
    console.log('togle')
  }

  // let expanded = false;

  // const expandLotes = {

  //   onExpand: (row, isExpand, rowIndex, e) => {
  //     expanded = isExpand;
  //     idxGrid = rowIndex;
  //     // if (modalLotes === false) {
  //     //   dataLotes = [];
  //     // }
  //     // console.log(row.id);
  //     // console.log(isExpand);
  //     //console.log(rowIndex);
  //     // console.log('onExpand');
  //     //console.log(e);
  //   },

  //   onExpandAll: (isExpandAll, rows, e) => {
  //     setIdxExpanded([])
  //     // console.log(isExpandAll);
  //     // console.log(rows);
  //     // console.log(e);
  //   },

  //   renderer: row => (

  //     <>

  //       {

  //         //expanded 
  //         //?//se tiver expandindo          
  //         row.det.prod.rastro
  //           ? //se existir o rastro
  //           Array.isArray(row.det.prod.rastro)
  //             ? //se for mais de um lote
  //             row.det.prod.rastro.map((lote, idx) => {
  //               //limpa o array antes de preencher                
  //               if (idx === 0) {
  //                 dataLotes = [];
  //               }

  //               dataLotes.push({
  //                 nLote: lote.nLote._text,
  //                 qLote: lote.qLote._text,
  //                 dFab: lote.dFab._text,
  //                 dVal: lote.dVal._text
  //               })

  //             })

  //             ://se for apenas um lote
  //             // dataLotes.map(lt=>{
  //             //   // lt = undefined;
  //             //   lt = {
  //             //     nLote : row.det.prod.rastro.nLote._text,
  //             //     qLote : row.det.prod.rastro.qLote._text,
  //             //     dFab : row.det.prod.rastro.dFab._text,
  //             //     dVal : row.det.prod.rastro.dVal._text
  //             //   }  
  //             // })

  //             populaDatalotes(row)

  //           // dataLotes.push({
  //           //   nLote: row.det.prod.rastro.nLote._text,
  //           //   qLote: row.det.prod.rastro.qLote._text,
  //           //   dFab: row.det.prod.rastro.dFab._text,
  //           //   dVal: row.det.prod.rastro.dVal._text
  //           // })
  //           : //se nao existir o rastro
  //           populaDatalotes(row)
  //         // : //se estiver recolhendo
  //         //console.log('recolheu')

  //       }

  //       {

  //         loadingLotes
  //           ? <>
  //             <Loading
  //               tipo='componente'
  //             ></Loading>
  //           </>
  //           :
  //           <>
  //             <Col md='9'>
  //               <BootstrapTable
  //                 data={dataLotes}
  //                 columns={colunasLotes}
  //                 striped
  //                 condensed
  //                 trClassName="customClass"
  //                 keyField='idx'
  //                 noDataIndication="Nenhum lote encontrado"
  //                 //rowStyle={rowStyle2}
  //                 // {...props.baseProps}
  //                 cellEdit={
  //                   cellEditFactory({
  //                     mode: 'dbclick',
  //                     onStartEdit: (row, column, rowIndex, columnIndex) => { idxLote = rowIndex },
  //                     afterSaveCell: (oldValue, newValue, row, column) => { onChangeNovoLote(column.text, newValue, idxGrid, idxLote) }

  //                   })
  //                 }
  //                 // onTableChange={(type, { data, cellEdit: { rowId, dataField, newValue } }) => handleLoteChange(type, { data, cellEdit: { rowId, dataField, newValue } })}
  //                 onTableChange={handleLoteChange}
  //               />
  //             </Col>
  //             {/* <Button
  //               onClick={() => {
  //                 const lote = {
  //                   nLote: '',
  //                   qLote: '',
  //                   dFab: '',
  //                   dVal: ''
  //                 }
  //                 setNovoLote(lote);
  //                 adicionaLote(row.idx)

  //                 //setModalLotes(true);

  //               }}
  //             >Adicionar Lote</Button> */}
  //           </>
  //       }
  //     </>
  //   ),
  //   expanded: idxExpanded,
  //   showExpandColumn: true,
  //   expandByColumnOnly: true,
  //   //onlyOneExpanding: true
  // }

  const listaDestinatario = () => {

    const cnpj = formulario.dadosNota.dest.CNPJ._text;

    if (cnpj) {
      //console.log('com cnpj')
      const url = settings.url + rotas.listarDestinatario;
      const retorno = rest.get(url + '?cnpj=' + cnpj);

      retorno.then(ret => {
        if (ret.success === 'S') {
          setDestinatario(ret.retorno);
        }
        setDisableBtnLocalizar(false);
      })
    } else {
      //console.log('sem cnpj')
    }

  }

  const listaProdutos = () => {
    let parametros = {
      cnpj_loja: '',
      produtos: []
    };
    let retornoProdutos = [];

    const jxml = normalizaJxml(JSON.parse(xml2json(xml, { compact: true, spaces: 4 })));

    // console.log('lista produtos');

    //PEGA O CNPJ DO DESTINATARIO PARA SABER DE QUAL LOJA E A NOTA
    parametros.cnpj_loja = jxml.nfeProc.NFe.infNFe.dest.CNPJ._text;

    //PEGA OS DADOS DO FORNECEDOR PARA CADASTRAR CASO ELE NAO EXISTA
    parametros.dadosFornecedor = jxml.nfeProc.NFe.infNFe.emit;

    //PEGA OS PRODUTOS DA NOTA

    //SE DET FOR UM ARRAY E PORQUE TEM MAIS DE UM PRODUTO
    //SENAO ELE NAO E UM ARRAY

    if (Array.isArray(jxml.nfeProc.NFe.infNFe.det)) {
      jxml.nfeProc.NFe.infNFe.det.map(produto => {

        if ((produto.prod.cEAN._text !== 'SEM GTIN') &&
          (produto.prod.cEAN._text !== '') &&
          (produto.prod.cEAN._text !== '0')) {

          parametros.produtos.push({
            cod_barras: produto.prod.cEAN._text.replace('SEM GTIN', '0'),
          })

        }

      });
    } else {
      if ((jxml.nfeProc.NFe.infNFe.det.prod.cEAN._text !== 'SEM GTIN') &&
        (jxml.nfeProc.NFe.infNFe.det.prod.cEAN._text !== '') &&
        (jxml.nfeProc.NFe.infNFe.det.prod.cEAN._text !== '0')) {

        parametros.produtos.push({
          cod_barras: jxml.nfeProc.NFe.infNFe.det.prod.cEAN._text.replace('SEM GTIN', '0'),
        })
      }
    }

    const url = settings.url + rotas.listarProdutosNfe;
    const retorno = rest.post(url, parametros);
    retorno.then(ret => {
      if (ret.success === "S") {

        //valida permissao de cadastro de produto
        if (ret.cadastro_produto) {
          if (ret.cadastro_produto === 'S') {
            setPermiteCadastroProduto(true)
          } else {
            setPermiteCadastroProduto(false)
          }
        }

        //console.log(parametros)
        ret.produtos.map(produto =>
          retornoProdutos.push({
            produto_id:   produto.produto_id,
            produto:      produto.produto,
            cod_barras:   produto.cod_barras,
            hospitalar:   produto.hospitalar,
            prod_prvenda: produto.prod_prvenda,
            cod_barras_hospitalar: produto.cod_barras_hospitalar,
            atualizar_preco: produto.atualizar_preco,
            tipo_preco: produto.tipo_preco,
            margem_lucro: produto.margem_lucro,
            tipo_preco: produto.tipo_preco,
            preco_matriz: produto.preco_matriz,
            prod_ativo: produto.prod_ativo,
            psicotropico: produto.psicotropico,
            antimicrobiano: produto.antimicrobiano,
            collapse_lote: false,
            uso_consumo: produto.uso_consumo,
            valor_ult_compra: produto.valor_ult_compra,
            prod_prpromocao: produto.prod_prpromocao,
            prod_prcrediario: produto.prod_prcrediario
          })
        );
        setProdutosSite(retornoProdutos);
      }
    })
    verificaFornecedorNfe(jxml.nfeProc.NFe.infNFe.emit.CNPJ._text);
  }

  const dadosProdutoSite = (cod_barras) => {
    let x = 0;
    for (x = 0; x < produtosSite.length; x++) {
      if ((cod_barras === produtosSite[x].cod_barras) || (cod_barras === produtosSite[x].cod_barras_hospitalar)) {
        return (produtosSite[x])
      } else {
        // console.log('nao achou')
      }
    }
  }

  const calculaPrecoReajustado = (dadosDigi, dadosNota) => {
    let valorUnitario = 0;
    let mkp = 0;
    let valorST = 0;
    let imposto = {};

    if (dadosDigi) {

      //se o tipo de preco for monitorado
      if (dadosDigi.tipo_preco === 'M') {
        //se for para atualizar preco automaticamente e tiver pmc na nota
        //o valor calculado e o proprio pmc
        if ((dadosNota.prod.med) && (dadosDigi.atualizar_preco === 'S')) {

          return (toDecimal(dadosNota.prod.med.vPMC._text / dadosNota.prod.Hospitalar._text))
        }
        //se tiver pmc mas "nao" for pra atualizar preco
        //entao o valor e o prvenda
        if ((dadosNota.prod.med) && (dadosDigi.atualizar_preco === 'N')) {
          return (dadosDigi.prod_prvenda);
        }
        //se "nao" tiver pmc e "nao" for pra atualizar preco
        //entao o valor e o prvenda
        if (!dadosNota.prod.med) {
          return (dadosDigi.prod_prvenda);
        }
      }

      //se o tipo de preco for liberado
      if (dadosDigi.tipo_preco === 'L') {

        //se tiver margem de lucro
        //faz o calculo

        if (dadosDigi.margem_lucro > 0) {
          imposto = getICMS(dadosNota.imposto);

          let desconto = dadosNota.prod.vDesc ? dadosNota.prod.vDesc._text : 0;
          let fcpst = imposto.vFCPST ? (imposto.vFCPST._text / dadosNota.prod.qCom._text) : 0;
          let despesa = dadosNota.prod.vOutro ? (dadosNota.prod.vOutro._text / dadosNota.prod.qCom._text) : 0;
          // console.log(dadosNota.prod.vProd,desconto,dadosNota.prod.qCom)

          valorUnitario = ((dadosNota.prod.vProd._text - desconto) / dadosNota.prod.qCom._text);

          //se for produto hospitalar, divide o preco encontrado pela quantidade fracionada
          if (dadosNota.prod.Hospitalar) {
            if (dadosNota.prod.Hospitalar._text > 1) {
              valorUnitario = valorUnitario / dadosNota.prod.Hospitalar._text;
            }
          }

          valorST = imposto.vICMSST ? (imposto.vICMSST._text / dadosNota.prod.qCom._text) : 0;

          //modificação por causa do calculo da embalagem hospitalar sobre o valor do st - modificado dia 26/10/2023
          if (dadosNota.prod.Hospitalar) {
            if (dadosNota.prod.Hospitalar._text > 1) {
              if (valorST > 0) {
                valorST = valorST / dadosNota.prod.Hospitalar._text;
              }
            }
          }

          valorUnitario = valorUnitario + valorST + fcpst + despesa;

          mkp = (((valorUnitario) * dadosDigi.margem_lucro) / 100);

          mkp = mkp.toFixed(2);
          valorUnitario = valorUnitario.toFixed(2);

          let ret = Number(valorUnitario) + Number(mkp);

          return (Number(ret.toFixed(2)));

        } else {//se nao tiver margem de lucro
          //entao o valor e o prvenda
          return (dadosDigi.prod_prvenda);
        }
      }
    } else {//se o produto nao tiver cadastrado retorna zero
      return (0);
    }
  }

  const listaNota = () => {
    //console.log('listaNota');
    try {
    setDisableBtnLocalizar(true)
    const jxml = normalizaJxml(JSON.parse(xml2json(xml, { compact: true, spaces: 4 })));

    //console.log(jxml.nfeProc.NFe.infNFe.total)

    //PEGA OS DADOS DO CABECALHO DA NOTA
    const dadosNota = {
      _attributes: jxml.nfeProc.NFe.infNFe._attributes,
      ide: jxml.nfeProc.NFe.infNFe.ide,
      emit: jxml.nfeProc.NFe.infNFe.emit,
      dest: jxml.nfeProc.NFe.infNFe.dest,
      total: jxml.nfeProc.NFe.infNFe.total,
      cobr: jxml.nfeProc.NFe.infNFe.cobr,
      pag: jxml.nfeProc.NFe.infNFe.pag,
      infAdic: jxml.nfeProc.NFe.infNFe.infAdic
    }

    //PEGA OS PRODUTOS DA NOTA

    //SE TIVER APENAS 1 ITEM NA NOTA O DET NAO E UM ARRAY
    //AQUI EU TRANFORMO ELE NUM ARRAY
    let detProdutos = [];

    if (Array.isArray(jxml.nfeProc.NFe.infNFe.det) === false) {
      detProdutos = [jxml.nfeProc.NFe.infNFe.det];
    } else {
      detProdutos = jxml.nfeProc.NFe.infNFe.det;
    }

    detProdutos.map(produto => {
      //console.log(produto);
      const dadosSite = dadosProdutoSite(produto.prod.cEAN._text);

      //let mTempProd = produto.prod;

      produto.prod.produto_id_original = {
        _text: dadosSite ? dadosSite.produto_id : ''
      };

      produto.prod.CFOP._text = converteCFOP(produto.prod.CFOP._text);

      produto.prod.xProd = {
        _text: dadosSite ? dadosSite.produto : produto.prod.xProd._text
      };

      produto.prod.Hospitalar = {
        _text: dadosSite ? dadosSite.hospitalar : ''
      };

      produto.prod.prod_prvenda = {
        _text: dadosSite ? dadosSite.prod_prvenda : ''
      };

      produto.prod.margem_lucro = {
        _text: dadosSite ? dadosSite.margem_lucro : ''
      };

      produto.prod.tipo_preco = {
        _text: dadosSite ? dadosSite.tipo_preco : ''
      };

      // produto.prod.prod_prpromocao = {
      //   _text: dadosSite ? dadosSite.prod_prpromocao : ''
      // };

      produto.prod.valor_total = {
        _text: '0'
      };

      produto.prod.prVendaCorrigido = {
        _text: calculaPrecoReajustado(dadosSite, produto)
      };

      produto.prod.preco_matriz = {
        _text: dadosSite ? dadosSite.preco_matriz : ''
      };

      produto.prod.prod_ativo = {
        _text: dadosSite ? dadosSite.prod_ativo : 'S'
      }

      produto.prod.psicotropico = {
        _text: dadosSite ? dadosSite.psicotropico : ''
      }

      produto.prod.antimicrobiano = {
        _text: dadosSite ? dadosSite.antimicrobiano : ''
      }

      produto.prod.valor_ult_compra = {
        _text: dadosSite ? dadosSite.valor_ult_compra : '0'
      }

      produto.prod.prod_prpromocao = {
        _text: dadosSite ? dadosSite.prod_prpromocao : '0'
      }

      produto.prod.prod_prcrediario = {
        _text: dadosSite ? dadosSite.prod_prcrediario : '0'
      }

      produto.prod.uso_consumo = {
        _text: dadosSite ? (dadosSite.uso_consumo || 'N') : 'N'
      }

      if (produto.prod.rastro) {

        if (Array.isArray(produto.prod.rastro)) {

          produto.prod.rastro.map(lote => {
            lote.dFab._text = moment(lote.dFab._text).format('DD/MM/YYYY');
            lote.dVal._text = moment(lote.dVal._text).format('DD/MM/YYYY');
            lote.qLote._text = lote.qLote._text.replace(',', '.');
            lote.qLote._text = parseInt(lote.qLote._text);
          })
        } else {
          produto.prod.rastro.dFab._text = moment(produto.prod.rastro.dFab._text).format('DD/MM/YYYY');
          produto.prod.rastro.dVal._text = moment(produto.prod.rastro.dVal._text).format('DD/MM/YYYY');
          produto.prod.rastro.qLote._text = produto.prod.rastro.qLote._text.replace(',', '.');
          produto.prod.rastro.qLote._text = parseInt(produto.prod.rastro.qLote._text);
        }

        // produto.prod.rastro = trataDataLotes(produto.prod.rastro);
      }

      //console.log(produto);
      let mDet = {
        idx: (produto._attributes.nItem - 1),
        det: {

        }

      };
      mDet.det = produto;
      //mDet.idx = produto._attributes.nItem - 1;
      //mDet.det._attributes=_attributes;
      produtosNfe.push(mDet);

      if (produto.prod.produto_id_original._text === '') {
        notaOK = false;
        setBtDisabled(true);
      }
    });

    const notaFiscal = {
      nao_incluir_st: formulario.nao_incluir_st,
      dividir_desconto: formulario.dividir_desconto,
      // lancar_duplicatas: formulario.lancar_duplicatas,
      dadosNota: dadosNota,
      produtosNfe: produtosNfe
    }
    setfomulario(notaFiscal);
    calculaTotaisNota(notaFiscal);

    } catch (e) {
      // Erro na leitura do XML — garante que nenhum estado de carregamento fica travado
      setProcessandoNota(false);
      setLoading(false);
      setBtDisabled(true);
      setDisableBtnLocalizar(false);
      console.error('listaNota erro:', e);
      setTimeout(() => {
        if (!Swal.isVisible()) {
          Swal.fire(
            'Erro ao ler a nota fiscal',
            'Não foi possível processar o XML desta nota. O arquivo pode estar com estrutura inválida ou incompleta.',
            'error'
          );
        }
      }, 0);
    }
  }

  const localizaProduto = (cod_barras) => {
    //console.log(cod_barras);
    const listaProdutos = { produtos: [] };

    listaProdutos.produtos.push({ cod_barras: cod_barras });
    listaProdutos.cnpj_loja = formulario.dadosNota.dest.CNPJ._text;

    const url = settings.url + rotas.listarProdutosNfe;
    //console.log(listaProdutos)
    const retorno = rest.post(url, listaProdutos);
    return retorno;
  }

  const sleep = async () => {
    setTimeout(() => {

    }, 1000)
  }

  const handleLoteChange = (type, { data, cellEdit: { rowId, dataField, newValue } }) => {
    console.log(data, rowId);
  }

  const handleTableChange = (type, data, rowId, dataField, newValue) => {
    // console.log('handle');
    //data[rowId].det.prod.cEAN._text = newValue;
    //data[rowId].det.prod.xProd._text = 'teste';

    ////setRefresh(prev => prev + 1);
    //data[rowId].det.prod.xProd = 'produto';

    if (dataField === 'cst') {
      if (newValue.length > 3) {
        newValue = CSTxmlToCST(data[rowId].det.imposto);
      }
      if (newValue.length < 3) {
        newValue = CSTxmlToCST(data[rowId].det.imposto);
      }
    }


    const result = data.map((row, idx) => {
      const newRow = { ...row };

      if (row.idx === rowId) {

        if (dataField === 'hospitalar') {
          row.det.prod.Hospitalar._text = Math.round(newValue.replace(',', '.'));
          setRefresh(prev => prev + 1)
        }

        if (dataField === 'prVendaCorrigido') {
          // row.det.prod.prVendaCorrigido._text = newValue.replace(',', '.');
          newValue = newValue.replace(/[^0-9]/g, '') + '';
          if (newValue.length > 9) {
            newValue = newValue.substring(newValue.length - 9, newValue.length);
          }

          newValue = (newValue / 100) + '';

          row.det.prod.prVendaCorrigido._text = newValue;
          // row.det.prod.prVendaCorrigido._text = (newValue.replace(/[^0-9]/g, '') / 100);
          //let nv = newValue.replace(/[^0-9]/g, '')/100; 
          // console.log(row.det.prod.prVendaCorrigido._text)
          setRefresh(prev => prev + 1)
        }

        // if (dataField === 'prod_prpromocao') {
        //   newValue = newValue.replace(/[^0-9]/g, '') + '';
        //   if(newValue.length > 9){
        //     newValue = newValue.substring(newValue.length-9,newValue.length);
        //   }

        //   newValue = (newValue /100) + '';

        //   row.det.prod.prod_prpromocao._text = newValue;
        //   // row.det.prod.prVendaCorrigido._text = newValue.replace(',', '.');
        //   // row.det.prod.prod_prpromocao._text = (newValue.replace(/[^0-9]/g, '') / 100);
        //   //let nv = newValue.replace(/[^0-9]/g, '')/100; 
        //   // console.log(row.det.prod.prVendaCorrigido._text)
        //   setRefresh(prev => prev + 1)
        // }

        if (dataField === 'prod_prpromocao') {
          newValue = newValue.replace(/[^0-9]/g, '') + '';
          if (newValue.length > 9) newValue = newValue.substring(newValue.length - 9, newValue.length);
          newValue = (newValue / 100) + '';
          row.det.prod.prod_prpromocao._text = newValue;
          setRefresh(prev => prev + 1)
        }

        if (dataField === 'prod_prcrediario') {
          newValue = newValue.replace(/[^0-9]/g, '') + '';
          if (newValue.length > 9) newValue = newValue.substring(newValue.length - 9, newValue.length);
          newValue = (newValue / 100) + '';
          row.det.prod.prod_prcrediario._text = newValue;
          setRefresh(prev => prev + 1)
        }

        if (dataField === 'preco_matriz') {
          row.det.prod.preco_matriz._text = (newValue.replace(/[^0-9]/g, '') / 100);
          setRefresh(prev => prev + 1)
        }

        if (dataField === 'cEAN') {
          alteraCodBarras(row.idx, newValue);
        }

        if (dataField === 'CFOP') {
          if (newValue.length !== 4) {
            newValue = data[rowId].det.prod.CFOP._text;
          }
          row.det.prod.CFOP._text = newValue;
          setRefresh(prev => prev + 1)
        }

        if ((dataField === 'aliquotaIcms') ||
          (dataField === 'cst') ||
          (dataField === 'valorST')) {
          alteraICMS(rowId, newValue.replace(',', '.'), data[idx].det.imposto, dataField);
        }

        if (dataField === 'margem_lucro') {
          let dadosSite = dadosProdutoSite(data[idx].det.prod.cEAN._text);
          if (parseFloat(data[idx].det.prod.margem_lucro._text) > 0) {
            dadosSite.margem_lucro = newValue.replace(',', '.');
            row.det.prod.margem_lucro._text = dadosSite.margem_lucro;
            row.det.prod.prVendaCorrigido._text = calculaPrecoReajustado(dadosSite, data[idx].det);
            setRefresh(prev => prev + 1);
          }
        }

        // V-04: alerta se preço de venda calculado < custo
        if (dataField === 'prVendaCorrigido') {
          const custo = parseFloat(row.det.prod.vUnCom ? row.det.prod.vUnCom._text : 0);
          const venda = parseFloat(row.det.prod.prVendaCorrigido._text);
          if (custo > 0 && venda < custo) {
            Swal.fire('Atenção', `Preço de venda (${toBRL(venda)}) está abaixo do custo (${toBRL(custo)}) para o produto ${row.det.prod.xProd._text}.`, 'warning');
          }
        }

        // V-05: alerta se CFOP de saída foi digitado em NF de entrada
        if (dataField === 'CFOP') {
          const primeiroDigito = String(row.det.prod.CFOP._text).charAt(0);
          if (primeiroDigito === '5' || primeiroDigito === '6') {
            Swal.fire('Atenção', `CFOP ${row.det.prod.CFOP._text} é de operação de saída. Verifique se está correto para esta NF-e de entrada.`, 'warning');
          }
        }
      }
    });

    setfomulario({ ...formulario });
  }

  const alteraCodBarras = (idx, newValue) => {

    let newForm = { ...formulario };

    setStatusCodBarras(prev => ({ ...prev, [idx]: 'loading' }));

    const retorno = localizaProduto(newValue);

    retorno.then(ret => {
      if (ret && ret.produtos && ret.produtos.length > 0) {
        newForm.produtosNfe[idx].det.prod.cEAN._text = ret.produtos[0].cod_barras;
        newForm.produtosNfe[idx].det.prod.produto_id_original._text = ret.produtos[0].produto_id;
        newForm.produtosNfe[idx].det.prod.xProd._text = ret.produtos[0].produto;
        newForm.produtosNfe[idx].det.prod.Hospitalar._text = ret.produtos[0].hospitalar;
        newForm.produtosNfe[idx].det.prod.prod_prvenda._text = ret.produtos[0].prod_prvenda;
        newForm.produtosNfe[idx].det.prod.prVendaCorrigido._text = calculaPrecoReajustado(ret.produtos[0], newForm.produtosNfe[idx].det);
        newForm.produtosNfe[idx].det.prod.preco_matriz._text = ret.produtos[0].preco_matriz;
        newForm.produtosNfe[idx].det.prod.margem_lucro._text = ret.produtos[0].margem_lucro;
        newForm.produtosNfe[idx].det.prod.tipo_preco._text = ret.produtos[0].tipo_preco;
        newForm.produtosNfe[idx].det.prod.prod_ativo._text = ret.produtos[0].prod_ativo;
        newForm.produtosNfe[idx].det.prod.valor_ult_compra._text = ret.produtos[0].valor_ult_compra || '0';
        newForm.produtosNfe[idx].det.prod.prod_prpromocao._text = ret.produtos[0].prod_prpromocao || '0';
        newForm.produtosNfe[idx].det.prod.prod_prcrediario._text = ret.produtos[0].prod_prcrediario || '0';

        setStatusCodBarras(prev => ({ ...prev, [idx]: 'found' }));
        setTimeout(() => {
          setStatusCodBarras(prev => {
            const next = { ...prev };
            if (next[idx] === 'found') delete next[idx];
            return next;
          });
        }, 2500);

        setfomulario(newForm);
      } else {
        setStatusCodBarras(prev => ({ ...prev, [idx]: 'notFound' }));
      }



    }).catch(() => {
      setStatusCodBarras(prev => ({ ...prev, [idx]: 'notFound' }));
    })
  }

  const alteraICMS = (rowId, newValue, row, tipo) => {

    if ((tipo === 'cst') && (newValue.length > 3)) {
      newValue = newValue.substring(1, 4);
    }

    let idx = rowId;

    const mICMS = getICMS(formulario.produtosNfe[idx].det.imposto);
    let oICMS = {};
    //se for cst
    if (mICMS.CST) {
      oICMS = {
        orig: {
          _text: mICMS.orig ? mICMS.orig._text : 0,
        },
        CST: {
          _text: mICMS.CST ? mICMS.CST._text : 0
        },
        modBC: {
          _text: mICMS.modBC ? mICMS.modBC._text : 0
        },
        pRedBC: {
          _text: mICMS.pRedBC ? mICMS.pRedBC._text : 0
        },
        vBC: {
          _text: mICMS.vBC ? mICMS.vBC._text : 0
        },
        pICMS: {
          _text: mICMS.pICMS ? mICMS.pICMS._text : 0
        },
        vICMS: {
          _text: mICMS.vICMS ? mICMS.vICMS._text : 0
        },
        modBCST: {
          _text: mICMS.modBCST ? mICMS.modBCST._text : 0
        },
        pMVAST: {
          _text: mICMS.pMVAST ? mICMS.pMVAST._text : 0
        },
        pRedBCST: {
          _text: mICMS.pRedBCST ? mICMS.pRedBCST._text : 0
        },
        vBCST: {
          _text: mICMS.vBCST ? mICMS.vBCST._text : 0
        },
        pICMSST: {
          _text: mICMS.pICMSST ? mICMS.pICMSST._text : 0
        },
        vICMSST: {
          _text: mICMS.vICMSST ? mICMS.vICMSST._text : 0
        },
        vBCFCPST: {
          _text: mICMS.vBCFCPST ? mICMS.vBCFCPST._text : 0
        },
        pFCPST: {
          _text: mICMS.pFCPST ? mICMS.pFCPST._text : 0
        },
        vFCPST: {
          _text: mICMS.vFCPST ? mICMS.vFCPST._text : 0
        },
        vICMSDeson: {
          _text: mICMS.vICMSDeson ? mICMS.vICMSDeson._text : 0
        },
        motDesICMS: {
          _text: mICMS.motDesICMS ? mICMS.motDesICMS._text : 0
        }
      }
    } else {//se for CSOSN
      oICMS = {
        orig: {
          _text: 0
        },
        CSOSN: {
          _text: mICMS.CSOSN ? mICMS.CSOSN : 0
        },
        modBC: {
          _text: mICMS.modBC ? mICMS.modBC._text : 0
        },
        vBC: {
          _text: mICMS.vBC ? mICMS.vBC._text : 0
        },
        pICMS: {
          _text: mICMS.pICMS ? mICMS.pICMS._text : 0
        },
        vICMS: {
          _text: mICMS.vICMS ? mICMS.vICMS._text : 0
        }
      }
    }


    if (tipo === 'cst') {
      if (mICMS.CST) {
        oICMS.orig._text = newValue.substring(0, 1);
        oICMS.CST._text = newValue.substring(1, 3);
      } else {
        oICMS.orig._text = 0;
        oICMS.CSOSN._text = newValue;
      }
      //const novoCst = newValue; 
    }

    if (tipo === 'valorST') {
      oICMS.vICMSST._text = newValue;
    }

    if (tipo === 'valorFCPST') {
      oICMS.vFCPST._text = newValue;
    }

    if (tipo === 'aliquotaIcms') {
      oICMS.pICMS._text = newValue;
    }

    if (tipo === 'CFOP') {
      formulario.produtosNfe[idx].det.prod.CFOP._text = newValue;
    }

    //formulario.produtosNfe[idx].det.prod.cst = novoCst;
    formulario.produtosNfe[idx].det.imposto.ICMS = setICMS(oICMS);

    setRefresh(prev => prev + 1);

    //console.log(formulario);
  }

  const recalculaMargemMkp = () => {
    setRefresh(prev => prev + 1);
  }

  const geraNovoXml = async () => {

    let produtosOK = true;
    let precoOK = true;
    let produtoInativo = false;
    let loteOK = true;

    const formEnvio = JSON.parse(JSON.stringify(formulario));

    formEnvio.produtosNfe.map(produto => {
      if (produto.det.prod.produto_id_original._text === '') {
        produtosOK = false;
        //console.log('produto nao localizado');
      }

      if (produto.det.prod.prod_ativo._text === 'N') {
        produtoInativo = true;
      }
    })

    if (produtosOK) {

      //verifica se existem produtos com o preco de venda calculado = 0

      formEnvio.produtosNfe.map(produto => {
        if (produto.det.prod.prVendaCorrigido._text == 0) {
          precoOK = false
        }
      });

      if (!precoOK) {

        Swal.fire('Atenção',
          'Existem produtos com preço calculado igual a zero!',
          'error');
        return

      }

      //verifica se o total do lote bate com o total de itens
      //para produtos controlados 
      formEnvio.produtosNfe.map(produto => {
        if ((produto.det.prod.psicotropico._text === 'S') || (produto.det.prod.antimicrobiano._text === 'S')) {
          let totalItem = Number(produto.det.prod.qCom._text);
          let totalLote = 0;

          if (Array.isArray(produto.det.prod.rastro)) {
            produto.det.prod.rastro.map(lote => {
              totalLote += Number(lote.qLote._text);
            })

            if (totalItem !== totalLote) {

              loteOK = false;

              Swal.fire('Atenção',
                'A quantidade de lote do produto ' +
                produto.det.prod.xProd._text +
                ' está diferente da quantidade do item na nota',
                'warning');
              return;
            }

          } else {
            if (produto.det.prod.rastro) {
              let totalItem = produto.det.prod.qCom._text;
              let totalLote = produto.det.prod.rastro.qLote._text;

              if (Number(totalItem) !== Number(totalLote)) {

                loteOK = false;

                Swal.fire('Atenção',
                  'A quantidade de lote do produto ' +
                  produto.det.prod.xProd._text +
                  ' está diferente da quantidade do item na nota',
                  'warning');
                return;
              }
            }
          }
        }
      });

      if (!loteOK) {
        return;
      }

      loteOK = true;

      //antes de processar volta a data dos lotes para o padrao americano
      //e tambem multiplica o preco dos produtos hospitalares 
      //pela quantidade fracionada porque no lancamento o digifarma 
      //faz a divisao do valor do preco de venda calculado aqui

      formEnvio.produtosNfe.map(produto => {

        if (produto.det.prod.Hospitalar._text > 1) {
          produto.det.prod.prVendaCorrigido._text = produto.det.prod.prVendaCorrigido._text * produto.det.prod.Hospitalar._text;
        }
        if (produto.det.prod.rastro) {
          if (Array.isArray(produto.det.prod.rastro)) {

            //caso o ultimo registro seja vazio, remove ele
            let t = (produto.det.prod.rastro.length - 1);

            if ((produto.det.prod.rastro[t].nLote._text == '') &&
              (produto.det.prod.rastro[t].qLote._text == '') &&
              (produto.det.prod.rastro[t].dFab._text == '') &&
              (produto.det.prod.rastro[t].dVal._text == '')) {
              produto.det.prod.rastro.pop();
            }

            produto.det.prod.rastro.map(lote => {
              lote.dFab._text = moment(lote.dFab._text, "DD/MM/YYYY").format('YYYY-MM-DD');
              lote.dVal._text = moment(lote.dVal._text, "DD/MM/YYYY").format('YYYY-MM-DD');
            })
          } else {
            produto.det.prod.rastro.dFab._text = moment(produto.det.prod.rastro.dFab._text, "DD/MM/YYYY").format('YYYY-MM-DD');
            produto.det.prod.rastro.dVal._text = moment(produto.det.prod.rastro.dVal._text, "DD/MM/YYYY").format('YYYY-MM-DD');
          }
        }
      })


      //verifica se todos os campos de lote foram preenchidos
      formEnvio.produtosNfe.map(produto => {

        if (Array.isArray(produto.det.prod.rastro)) {
          produto.det.prod.rastro.map(lote => {

            if ((lote.nLote._text === '') ||
              (lote.qLote._text === '') ||
              (lote.dFab._text === '') ||
              (lote.dVal._text === '') ||
              (lote.dFab._text == 'Data inválida') ||
              (lote.dVal._text == 'Data inválida')) {

              loteOK = false;

              Swal.fire('Atenção',
                'As informações do lote do produto ' +
                produto.det.prod.xProd._text +
                ' estão incorretas, verifique',
                'warning');
              return;

            }
          })

        } else {
          if (produto.det.prod.rastro) {
            if ((produto.det.prod.rastro.dFab._text == 'Data inválida') ||
              (produto.det.prod.rastro.dVal._text == 'Data inválida')) {
              loteOK = false;

              Swal.fire('Atenção',
                'As informações do lote do produto ' +
                produto.det.prod.xProd._text +
                ' estão incorretas, verifique',
                'warning');
              return;

            }
          }
        }

      });

      if (!loteOK) {
        return;
      }

      loteOK = true;

      //verifica se o lote tem a data de validade maior que a data de fabricacao
      formEnvio.produtosNfe.map(produto => {

        if (Array.isArray(produto.det.prod.rastro)) {
          produto.det.prod.rastro.map(lote => {

            if (moment(lote.dFab._text).isAfter(lote.dVal._text)) {

              loteOK = false;

              Swal.fire('Atenção',
                'A data de validade do produto ' +
                produto.det.prod.xProd._text +
                ' está menor a data de fabricação, verifique',
                'warning');
              return;

            }
          })

        } else {
          if (produto.det.prod.rastro) {
            if (moment(produto.det.prod.rastro.dFab._text).isAfter(produto.det.prod.rastro.dVal._text)) {
              loteOK = false;

              Swal.fire('Atenção',
                'A data de validade do produto ' +
                produto.det.prod.xProd._text +
                ' está menor a data de fabricação, verifique',
                'warning');
              return;

            }
          }
        }

      });

      if (!loteOK) {
        return;
      }


      //verifica se o desonerado está sendo reduzido da nota 
      //e caso  nao esteja, zera ele
      const totalNota = Number(formEnvio.dadosNota.total.ICMSTot.vNF._text);
      const produtos = Number(formEnvio.dadosNota.total.ICMSTot.vProd ? formEnvio.dadosNota.total.ICMSTot.vProd._text : '0');
      const st = Number(formEnvio.dadosNota.total.ICMSTot.vST ? formEnvio.dadosNota.total.ICMSTot.vST._text : '0');
      const ipi = Number(formEnvio.dadosNota.total.ICMSTot.vIPI ? formEnvio.dadosNota.total.ICMSTot.vIPI._text : '0');
      const fcp = Number(formEnvio.dadosNota.total.ICMSTot.vFCP ? formEnvio.dadosNota.total.ICMSTot.vFCP._text : '0');
      const frete = Number(formEnvio.dadosNota.total.ICMSTot.vFrete ? formEnvio.dadosNota.total.ICMSTot.vFrete._text : '0');
      const outros = Number(formEnvio.dadosNota.total.ICMSTot.vOutro ? formEnvio.dadosNota.total.ICMSTot.vOutro._text : '0');
      const desconto = Number(formEnvio.dadosNota.total.ICMSTot.vDesc ? formEnvio.dadosNota.total.ICMSTot.vDesc._text : '0');
      const deson = Number(formEnvio.dadosNota.total.ICMSTot.vICMSDeson ? formEnvio.dadosNota.total.ICMSTot.vICMSDeson._text : '0');

      const soma = (produtos + st + ipi + fcp + frete + outros - desconto - deson);

      if (deson > 0) {
        //se soma for diferente da nota e a diferenca for justamente o desonerado
        //zera ele porque os produtos nao tiveram abatimento
        if ((soma != totalNota) && ((soma + deson) == totalNota)) {

          formEnvio.produtosNfe.map(produto => {
            if ((produto.det.imposto.ICMS.ICMS20) && (produto.det.imposto.ICMS.ICMS20.vICMSDeson)) {
              produto.det.imposto.ICMS.ICMS20.vICMSDeson._text = 0;
            }

            if ((produto.det.imposto.ICMS.ICMS40) && (produto.det.imposto.ICMS.ICMS40.vICMSDeson)) {
              produto.det.imposto.ICMS.ICMS40.vICMSDeson._text = 0;
            }

            if ((produto.det.imposto.ICMS.ICMS41) && (produto.det.imposto.ICMS.ICMS41.vICMSDeson)) {
              produto.det.imposto.ICMS.ICMS41.vICMSDeson._text = 0;
            }

            if ((produto.det.imposto.ICMS.ICMS50) && (produto.det.imposto.ICMS.ICMS50.vICMSDeson)) {
              produto.det.imposto.ICMS.ICMS50.vICMSDeson._text = 0;
            }

            if ((produto.det.imposto.ICMS.ICMS70) && (produto.det.imposto.ICMS.ICMS70.vICMSDeson)) {
              produto.det.imposto.ICMS.ICMS70.vICMSDeson._text = 0;
            }

            if ((produto.det.imposto.ICMS.ICMS90) && (produto.det.imposto.ICMS.ICMS90.vICMSDeson)) {
              produto.det.imposto.ICMS.ICMS90.vICMSDeson._text = 0;
            }
          })

          formEnvio.dadosNota.total.ICMSTot.vICMSDeson._text = '0';
        }
      }

      // V-02: alerta se há produtos com código de barras duplicado na nota
      const eans = formEnvio.produtosNfe.map(p => p.det.prod.cEAN._text).filter(e => e && e !== 'SEM GTIN');
      const eansDuplicados = eans.filter((e, i) => eans.indexOf(e) !== i);
      if (eansDuplicados.length > 0) {
        const lista = [...new Set(eansDuplicados)].join(', ');
        const { isConfirmed: continuarDup } = await Swal.fire({
          title: 'Produto duplicado na nota',
          text: `Os seguintes códigos de barras aparecem mais de uma vez na nota: ${lista}. Deseja continuar mesmo assim?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Continuar',
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
        });
        if (!continuarDup) return;
      }

      // V-01: valida se soma das duplicatas bate com o total da nota
      if (formEnvio.dadosNota.cobr && formEnvio.dadosNota.cobr.dup) {
        const dups = Array.isArray(formEnvio.dadosNota.cobr.dup)
          ? formEnvio.dadosNota.cobr.dup
          : [formEnvio.dadosNota.cobr.dup];
        const totalDups = dups.reduce((acc, d) => acc + Number(d.vDup ? d.vDup._text : 0), 0);
        const totalNfv = Number(formEnvio.dadosNota.total.ICMSTot.vNF._text);
        if (Math.abs(totalDups - totalNfv) > 0.02) {
          const { isConfirmed: continuarCobr } = await Swal.fire({
            title: 'Divergência nas duplicatas',
            text: `A soma das duplicatas (${toBRL(totalDups)}) difere do total da nota (${toBRL(totalNfv)}). Deseja continuar mesmo assim?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
            cancelButtonColor: '#d33',
          });
          if (!continuarCobr) return;
        }
      }

      //perguta ao usuario se deve lancar a duplicata

      // if((formulario.dadosNota.cobr)&&(formulario.dadosNota.cobr.dup)&&(destinatario[0].mensagem_dup == 'S')){

      //   Swal.fire({
      //     title: 'Gostaria de Lançar as Duplicatas desta Nota?',
      //     showDenyButton: true,
      //     showCancelButton: true,
      //     confirmButtonText: 'Sim',
      //     cancelButtonText: 'Não',
      //     cancelButtonColor: '#d33',
      //     icon: 'question'
      //   }).then((result) => {
      //     if (result.isConfirmed) {
      //       formEnvio.lancar_duplicatas = 'S'
      //     }else{
      //       formEnvio.lancar_duplicatas = 'N'
      //     }
      //     enviarXml(formEnvio);
      //   })
      // }else{
      if (produtoInativo) {
        Swal.fire({
          title: 'Atenção',
          text: 'Existem produtos inativos nesta nota. Ao lançar, esses itens serão ativados automaticamente pelo sistema. Deseja continuar?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, lançar',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then((result) => {
          if (result.isConfirmed) {
            enviarXml(formEnvio);
          }
        });
      } else {
        enviarXml(formEnvio);
      }

    } else {
      Swal.fire({
        title: "Erro",
        text: "Existem produtos não cadastrados!",
        icon: 'error'
      });
    }
  }

  const enviarXml = (formEnvio) => {

    let jxml = normalizaJxml(JSON.parse(xml2json(xml, { compact: true, spaces: 4 })));
    let newXml = '';
    jxml.nfeProc.NFe.infNFe = formEnvio.dadosNota;
    jxml.nfeProc.NFe.infNFe.produtos = formEnvio.produtosNfe;

    //coloca a flag para incluir ou nao o icms no total da nota
    //e para dividir ou nao o desconto pelo total dos itens
    const paramDigi = {
      naoIncluirST: { _text: formEnvio.nao_incluir_st },
      dividirDesconto: { _text: formEnvio.dividir_desconto },
      // lancarDuplicatas: {_text: formEnvio.lancar_duplicatas}
    }


    jxml.nfeProc.NFe.infNFe.digi = paramDigi;

    newXml = json2xml(jxml, { compact: true, spaces: 4 });
    // console.log(JSON.stringify(jxml));
    // console.log(newXml);
    // return;

    const url = settings.url + rotas.gravaNota;

    const parametros = {
      xml: newXml,
      xml_original: xmlOriginal
    }


    const retorno = rest.post(url, parametros);
    retorno.then(ret => {
      if (ret.success === 'S') {
        setBtDisabled(true);
        Swal.fire({
          title: 'Sucesso',
          text: ret.msg,
          icon: 'success'
        }).then(() => {
          Swal.fire({
            title: 'Gostaria de Atualizar o Preço de Venda na Matriz?',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            cancelButtonColor: '#d33',
            icon: 'question'
          }).then((result) => {
            if (result.isConfirmed) {
              atualizaPrecoMatriz();
            }
            verificaCpag();
          })
        })
      } else {
        Swal.fire({
          title: 'Erro',
          text: ret.msg || 'Erro ao lançar a nota fiscal.',
          icon: 'error'
        });
      }
    }).catch(() => {
      Swal.fire({
        title: 'Erro',
        text: 'Falha na comunicação com o servidor.',
        icon: 'error'
      });
    })
  }

  const calculaTotaisNota = (nota) => {
    const totalNota = Number(nota.dadosNota.total.ICMSTot.vNF._text);
    let totalCalculado = 0;
    let totalItem = 0;
    let totalST = 0;
    let stCompara = 0;
    let totalFCP = 0;
    let totalDesonerado = 0;
    let totalIPI = 0;
    let totalOutros = 0;
    let totalDesconto = 0;
    let descontoCompara = 0;

    //ANTES DE CALCULAR OS TOTAIS DA NOTA
    //VERIFICA SE O FORNECEDOR JA FOI CADASTRADO
    //PORQUE SENAO ESTIVER CADASTRADO, JA VAI ESTAR APRESENTANDO 
    //UMA MENSAGEM DIZENDO PRA AGUARDAR, SE APRESENTAR ESSA NOVA MENSAGEM
    //VAI SOBREPOR A ANTIGA CAUSANDO CONFUSAO
    if (fornSendoCadastrado) {
      return
    }


    // const forn_cnpj = formulario.dadosNota.emit.CNPJ._text;

    // const url = settings.url + rotas.fornecedorNfe;
    // const retorno = rest.get(url + '?forn_cnpj=' + forn_cnpj);
    // retorno.then(ret => {
    // if (ret.success === 'S') {
    nota.produtosNfe.map(produto => {
      totalItem = totalItem + Number(produto.det.prod.vUnCom._text) * Number(produto.det.prod.qCom._text);
      //totalItem = totalItem + Number(produto.det.prod.vProd._text);
      //console.log('total item',totalItem)
      //SE FOR PARA INCLUIR ST NO TOTAL DA NOTA
      const mICMS = getICMS(produto.det.imposto);

      if (nota.nao_incluir_st === 'N') {
        totalST = totalST + (mICMS.vICMSST ? Number(mICMS.vICMSST._text) : 0)
      } else {
        stCompara = stCompara + (mICMS.vICMSST ? Number(mICMS.vICMSST._text) : 0);
      }

      //SE N AO FOR PRA DIVIDIR O DESCONTO PELA QUANTIDADE
      if (nota.dividir_desconto === 'N') {
        totalDesconto = totalDesconto + (produto.det.prod.vDesc ? (Number(produto.det.prod.vDesc._text) * Number(produto.det.prod.qCom._text)) : 0);
        descontoCompara = descontoCompara + (produto.det.prod.vDesc ? (Number(produto.det.prod.vDesc._text) * Number(produto.det.prod.qCom._text)) : 0);
      } else {
        totalDesconto = totalDesconto + (produto.det.prod.vDesc ? ((Number(produto.det.prod.vDesc._text) / Number(produto.det.prod.qCom._text)) * Number(produto.det.prod.qCom._text)) : 0);
        descontoCompara = descontoCompara + (produto.det.prod.vDesc ? (Number(produto.det.prod.vDesc._text) * Number(produto.det.prod.qCom._text)) : 0);
      }

      //console.log(nota);

      if (produto.det.imposto.IPI) {
        totalIPI = totalIPI + (produto.det.imposto.IPI.IPITrib ? Number(produto.det.imposto.IPI.IPITrib.vIPI._text) : 0);
      }

      if ((produto.det.imposto.ICMS.ICMS40) && (produto.det.imposto.ICMS.ICMS40.vICMSDeson)) {
        totalDesonerado = totalDesonerado + Number(produto.det.imposto.ICMS.ICMS40.vICMSDeson._text);
      }

      totalOutros = totalOutros + (produto.det.prod.vOutro ? Number(produto.det.prod.vOutro._text) : 0);

    })
    totalItem = Number(totalItem.toFixed(2));
    totalST = Number(totalST.toFixed(2));
    totalIPI = Number(totalIPI.toFixed(2));
    totalDesconto = Number(totalDesconto.toFixed(2));

    totalCalculado = totalCalculado + totalItem + totalST + totalOutros + totalIPI - totalDesconto - totalDesonerado;
    totalCalculado = Number(totalCalculado.toFixed(2));

    // console.log('total desonerado',totalDesonerado)

    //SE O TOTAL CALCULADO FOR MENOR QUE O TOTAL DA NOTA
    //DESMARCA A OPCAO DE NAO INCLUIR ST NO TOTAL DA NOTA
    //POIS PROVAVELMENTE ELE FAZ PARTE DA NOTA
    if ((totalCalculado < Number(nota.dadosNota.total.ICMSTot.vNF._text) && (nota.nao_incluir_st === 'S'))) {
      nota.nao_incluir_st = 'N';
      setfomulario(nota);
      calculaTotaisNota(nota);
      return;
    }

    //SE O TOTAL CALCULADO FOR MENOR QUE O TOTAL DA NOTA
    //PROVAVELMENTE O DESCONTO E DIVIDIDO PELO TOTAL DOS ITENS
    //ENTAO PEDE PRA MARCAR A DIVISAO POR ITENS
    if (totalCalculado < Number(nota.dadosNota.total.ICMSTot.vNF._text) && (nota.dividir_desconto === 'N')) {
      nota.dividir_desconto = 'S';
      setfomulario(nota);
      calculaTotaisNota(nota);
      return;
    }

    //SE O TOTAL CALCULADO FOR MAIOR QUE O TOTAL DA NOTA
    //PROVAVELMENTE O DESCONTO NAO E DIVIDIDO PELO TOTAL DOS ITENS
    //ENTAO PEDE PRA DESMARCAR A DIVISAO POR ITENS
    if (totalCalculado > Number(nota.dadosNota.total.ICMSTot.vNF._text)) {
      nota.dividir_desconto = 'N';
      setfomulario(nota);
      calculaTotaisNota(nota);
      return;
    }
    // }
    // })

  }

  const mudaDesconto = (vlr) => {
    const frm = { ...formulario, dividir_desconto: vlr.target.checked ? 'S' : 'N' };
    setfomulario(frm);
    calculaTotaisNota(frm);
  }

  const mudaIncluirST = (vlr) => {
    const frm = { ...formulario, nao_incluir_st: vlr.target.checked ? 'S' : 'N' };
    setfomulario(frm);
    calculaTotaisNota(frm);
  }

  const atualizaPrecoMatriz = () => {

    const url = settings.url + rotas.atualizaPrecoMatrizNfe;

    let precosMatriz = [];

    const produtos = formulario.produtosNfe;

    produtos.map(prod => {
      precosMatriz.push({
        produto_id:      prod.det.prod.produto_id_original._text,
        preco_matriz:    prod.det.prod.prVendaCorrigido._text,
        prod_prpromocao: prod.det.prod.prod_prpromocao._text,
        prod_prcrediario:prod.det.prod.prod_prcrediario._text
      })
    })

    const parametros = { preco_matriz: precosMatriz };

    const retorno = rest.post(url, parametros);
    retorno.then(ret => {
      if (ret.success === 'S') {
        Swal.fire(
          'Sucesso',
          'Preços atualizados com sucesso na matriz, aguarde integração',
          'success');
      } else {
        Swal.fire(
          'Erro',
          'Erro atualizando preços na matriz',
          'error'
        )
      }
    })
  }

  const verificaFornecedorNfe = (forn_cnpj, tentativa = 0) => {
    if (tentativa >= 5) {
      Swal.fire('Atenção', 'Não foi possível verificar o cadastro do fornecedor após várias tentativas. Verifique manualmente.', 'warning');
      setFornSendoCadastrado(false);
      return;
    }
    const url = settings.url + rotas.fornecedorNfe;

    const retorno = rest.get(url + '?forn_cnpj=' + forn_cnpj);
    retorno.then(ret => {
      if (ret.success === 'N') {
        if (fornSendoCadastrado === false) {
          //console.log(fornSendoCadastrado);
          setFornSendoCadastrado(true);
        }

        let timerInterval
        Swal.fire({
          title: 'Aguarde!',
          html: 'Cadastrando Fornecedor',
          timer: 10000,
          timerProgressBar: true,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading()
            const b = Swal.getHtmlContainer().querySelector('b')
            timerInterval = setInterval(() => {
              b.textContent = Swal.getTimerLeft()
            }, 100)
          },
          willClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {

          }
          verificaFornecedorNfe(forn_cnpj, tentativa + 1);
        })
      } else {
        setFornSendoCadastrado(false);
      }
    })
  }

  const onChangeNovoLote = (campo, valor, idxGrid, idxLote) => {

    setLoadingLotes(true);
    setIdxExpanded([])
    // let lote = novoLote;
    // if (campo === 'Qtde') {
    //   lote.qLote._text = valor;
    // }
    // setNovoLote(lote);
    adicionaLote(idxGrid, idxLote, campo, valor);
    // setLoadingLotes(false);

  }

  const onChangeDataFab = (dados) => {
    //console.log(novoLote)
    let lote = novoLote;
    if (typeof dados === 'object') {
      lote.dFab._text = dados.format('YYYY-MM-DD');
      setNovoLote(lote);
    } else {
      Swal.fire('Atenção',
        'Formato da data Inválido, use o formato dd/mm/aaaa',
        'warning')
    }
    //console.log(novoLote)
  }

  const onChangeDataVal = (dados) => {
    let lote = novoLote;

    if (typeof dados === 'object') {
      lote.dVal._text = dados.format('YYYY-MM-DD');
      setNovoLote(lote);
    } else {
      Swal.fire('Atenção',
        'Data Inválida!',
        'warning')
    }
  }

  const adicionaLote = (idxGrid, idxLote, campo, valor) => {
    //if (novoLote.nLote !== '') {
    //setLoadingLotes(true);
    //novoLote.dFab._text = moment(novoLote.dFab._text).format('DD/MM/YYYY');
    //novoLote.dVal._text = moment(novoLote.dVal._text).format('DD/MM/YYYY');

    let form = { ...formulario };

    form.produtosNfe.map(produto => {
      if (produto.idx === idxGrid) {

        if (Array.isArray(produto.det.prod.rastro)) {
          //produto.det.prod.rastro.push(novoLote);

          produto.det.prod.rastro.map((lote, index) => {
            if (idxLote === index) {

              if (campo === 'Lote') {
                lote.nLote._text = valor;
              }

              if (campo === 'Qtde') {
                lote.qLote._text = parseInt(valor);
                // lote.qLote._text = Math.round(toDecimal(valor));
                //Math.round(toDecimal(valor))
              }

              if (campo === 'Fabricação') {
                let data = moment(valor, "DD/MM/YYYY");

                if (data !== 'Data inválida') {
                  lote.dFab._text = data.format("DD/MM/YYYY");
                }
              }

              if (campo === 'Validade') {
                let data = moment(valor, "DD/MM/YYYY");

                if (data !== 'Data inválida') {
                  lote.dVal._text = data.format("DD/MM/YYYY");
                }
              }

              //lote.dFab._text  = novoLote.dFab._text;
              //lote.dVal._text  = novoLote.dVal._text;
              setfomulario(form);
              // setRefresh(refresh+1)                
              setLoadingLotes(false);
              setIdxExpanded([idxGrid])
              setNovoLote(initialNovoLote);

            }
          })

          let t = (produto.det.prod.rastro.length - 1);

          //se o ultimo registro do array de lotes estiver 
          //totalmente preenchido, cria uma linha em branco
          //caso seja necessario adicionar mais um registro
          if ((produto.det.prod.rastro[t].nLote._text !== '') &&
            (produto.det.prod.rastro[t].qLote._text !== '') &&
            (produto.det.prod.rastro[t].dFab._text !== '') &&
            (produto.det.prod.rastro[t].dVal._text !== '')) {

            produto.det.prod.rastro.push({
              nLote: { _text: '' },
              qLote: { _text: '' },
              dFab: { _text: '' },
              dVal: { _text: '' }
            }
            )
          }


          //setModalLotes(false);
          //setLoadingLotes(false);

        } else {


          let loteAtual = produto.det.prod.rastro;

          if (loteAtual === undefined) {
            loteAtual = initialNovoLote;
            produto.det.prod.rastro = loteAtual;
          }

          //se tiver apenas 1 lote e o idxLote for 0 
          //esta editando o lote principal
          if ((idxLote === 0)) {

            if (campo === 'Lote') {
              loteAtual.nLote._text = valor;
            }

            if (campo === 'Qtde') {
              // loteAtual.qLote._text = valor.replace(/[^0-9.]/g, '');
              loteAtual.qLote._text = valor.replace(',', '.').replace(',', '.');
              loteAtual.qLote._text = parseInt(loteAtual.qLote._text);
              // loteAtual.qLote._text = Math.round(toDecimal(loteAtual.qLote._text))
            }

            if (campo === 'Fabricação') {
              let data = moment(valor, "DD/MM/YYYY");

              if (data !== 'Data inválida') {
                loteAtual.dFab._text = data.format("DD/MM/YYYY");
              }
            }

            if (campo === 'Validade') {
              let data = moment(valor, "DD/MM/YYYY");

              if (data !== 'Data inválida') {
                loteAtual.dVal._text = data.format("DD/MM/YYYY");
              }
            }

          } else {
            let loteAtual = produto.det.prod.rastro;
            let novaTag = [];
            let nvLote = initialNovoLote;

            if (campo === 'Lote') {
              nvLote.nLote._text = valor;
            }

            if (campo === 'Qtde') {
              nvLote.qLote._text = parseInt(valor);
            }

            if (campo === 'Fabricação') {
              let data = moment(valor, "DD/MM/YYYY");

              if (data !== 'Data inválida') {
                nvLote.dFab._text = data.format("DD/MM/YYYY");
              }
            }

            if (campo === 'Validade') {
              let data = moment(valor, "DD/MM/YYYY");

              if (data !== 'Data inválida') {
                nvLote.dVal._text = data.format("DD/MM/YYYY");
              }
            }

            novaTag.push(loteAtual);
            novaTag.push(nvLote);
            novaTag.push({
              nLote: { _text: '' },
              qLote: { _text: '' },
              dFab: { _text: '' },
              dVal: { _text: '' }
            });

            produto.det.prod.rastro = novaTag;

          }


          setfomulario(form);
          // setRefresh(refresh+1)
          //setModalLotes(false);
          setLoadingLotes(false);
          setIdxExpanded([idxGrid])
          setNovoLote(initialNovoLote);

        }
      }
    })
    //}


  }

  const removeLote = (row) => {

    let form = { ...formulario };

    setLoadingLotes(true);

    form.produtosNfe.map(produto => {

      if (Array.isArray(produto.det.prod.rastro)) {
        let novoLote = produto.det.prod.rastro;

        produto.det.prod.rastro.map((lote, idx) => {
          if ((lote.nLote._text === row.nLote) && (lote.qLote._text === row.qLote)) {
            novoLote.splice(idx, 1);
            produto.det.prod.rastro = novoLote;
            setfomulario(form)
            setLoadingLotes(false);

            setIdxExpanded([]);
            return;
          }
        });

      } else {
        if ((produto.det.prod.rastro.nLote._text === row.nLote) && (produto.det.prod.rastro.qLote._text === row.qLote)) {
          produto.det.prod.rastro = undefined;
          setfomulario(form);
          setLoadingLotes(false);

          setIdxExpanded([]);
        }
      }

    })
  }

  const onCloseModalCpag = () => {
    setIsOpenModalCpag(!isOpenModalCpag);
  }

  const onCloseModalCobranca = () => {
    setIsOpenModalCobranca(!isOpenModalCobranca);
  }

  const preparaCobranca = () => {
    let form = formulario;

    if (formulario.dadosNota.cobr && formulario.dadosNota.cobr.dup) {

      if (Array.isArray(formulario.dadosNota.cobr.dup)) {
        form.dadosNota.cobr.dup.map((dup, idx) => {
          dup.idx = idx;
        })
      } else {
        form.dadosNota.cobr.dup = [{
          idx: 0,
          nDup: { _text: form.dadosNota.cobr.dup.nDup._text },
          dVenc: { _text: form.dadosNota.cobr.dup.dVenc._text },
          vDup: { _text: form.dadosNota.cobr.dup.vDup._text },
        }];
      }
      setfomulario(form);
    }
  }

  if (loading) {
    return (
      <>
        <Loading
          tipo='paginas'
        />
      </>
    )
  } else {

    return (
      <div className="content">

        {processandoNota && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.93)',
            zIndex: 1050,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '18px'
          }}>
            <i className="fas fa-circle-notch fa-spin" style={{ fontSize: 52, color: '#4CAF50' }}></i>
            <p style={{ fontSize: 16, color: '#555', fontWeight: 600, margin: 0 }}>
              Processando nota fiscal...
            </p>
            <p style={{ fontSize: 13, color: '#999', margin: 0 }}>
              Consultando produtos e verificando status da nota
            </p>
          </div>
        )}

        <Container fluid style={{ maxWidth: '95%' }}>
          <Modal isOpen={isOpenModalCpag} size='lg'><NfeCPag onClose={onCloseModalCpag} cnpj={formulario.dadosNota.emit.CNPJ && formulario.dadosNota.emit.CNPJ._text}></NfeCPag></Modal>
          <Modal isOpen={isOpenModalCobranca} size='lg'><Cobranca onClose={onCloseModalCobranca} formulario={formulario} setFormulario={setfomulario} cobIdx={editCobIdx}></Cobranca></Modal>
          <Modal
            size='xl'
            isOpen={modal.visible}
          >
            <FormCadastroProduto
              produto_id={0}
              //setValor={this.setvalor.bind(this)}
              //insereProduto={() => { this.insereProduto() }}
              closeModal={setModal}
              dadosNfe={modal}
            >
            </FormCadastroProduto>
          </Modal>

          <Modal
            size='md'
            isOpen={modalLotes}
          >
            <ModalBody className="pb-0">
              <Form>
                <Row>
                  <Col md='6'>
                    <FormGroup>
                      <Label for="num_lote">Número Lote</Label>
                      <Input
                        className="inputSM"
                        name="num_lote"
                        id="num_lote"
                        onBlur={onChangeNovoLote}
                      //value={form.produto_id}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='6'>
                    <FormGroup>
                      <Label for="lote_quantidade">Qtde</Label>
                      <Input
                        className="inputSM"
                        name="lote_quantidade"
                        id="lote_quantidade"
                        type='number'
                        onBlur={onChangeNovoLote}
                      //value={form.produto_id}
                      />
                    </FormGroup>
                  </Col>

                </Row>

                <Row>

                  <Col md='6'>
                    <FormGroup>
                      <Label for="lote_fabricacao">Data Fabricação</Label>
                      <DateTime
                        //value={convertDate(tabloide.inicio_promocao)}
                        onBlur={onChangeDataFab}
                        timeFormat={false}
                        closeOnSelect={true}
                        inputProps={{
                          className: "form-control",
                          placeholder: "Data de Fabricação"
                        }}
                      />

                    </FormGroup>
                  </Col>



                  <Col md='6'>
                    <FormGroup>
                      <Label for="lote_validade">Data Vencimento</Label>

                      <DateTime
                        //value={convertDate(tabloide.inicio_promocao)}
                        onBlur={onChangeDataVal}
                        timeFormat={false}
                        closeOnSelect={true}
                        inputProps={{
                          className: "form-control",
                          placeholder: "Data de Validade"
                        }}
                      />
                    </FormGroup>
                  </Col>


                </Row>

                <Row>
                  <Col>
                    <Button
                    // onClick={() => { adicionaLote(row.idx) }}
                    >Gravar</Button>
                  </Col>

                  <Col>
                    <Button
                      onClick={() => { setModalLotes(false) }}
                    >Fechar</Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardBody>

                  {cnpjAlerta && (
                    <Alert color="danger" className="mb-3">
                      <strong>Atenção:</strong> O CNPJ do destinatário desta nota fiscal não corresponde a nenhuma loja cadastrada. Verifique se o arquivo XML está correto antes de lançar.
                    </Alert>
                  )}

                  {/* <ToolkitProvider
                    keyField="idx"
                    data={formulario.produtosNfe ? formulario.produtosNfe : []}
                    columns={colunas}

                  >
                    {
                      props => ( */}
                  <div>
                    <div className="border p-3">
                      <Form>
                        <Container>
                          {/* ── Dois mini-cards + linha de ação ─────────────────── */}
                          <Row className="align-items-stretch">

                            {/* Card 1 — Arquivo XML */}
                            <Col md="5">
                              <div style={{
                                border: '1px solid #e3e3e3',
                                borderRadius: 6,
                                padding: '10px 14px',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                gap: 8,
                              }}>
                                <small style={{ color: '#9a9a9a', fontWeight: 600, letterSpacing: 1, fontSize: 10 }}>
                                  📁 ARQUIVO XML
                                </small>
                                <CustomInput
                                  type="file"
                                  id="localizar"
                                  name="localizar"
                                  label={retornoXML}
                                  onChange={(change) => carregaXML(change.target.files)}
                                  disabled={disableBtnLocalizar}
                                />
                              </div>
                            </Col>

                            {/* Card 2 — Baixar por chave SEFAZ */}
                            <Col md="5">
                              <div style={{
                                border: '1px solid #e3e3e3',
                                borderRadius: 6,
                                padding: '10px 14px',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                gap: 8,
                              }}>
                                <small style={{ color: '#9a9a9a', fontWeight: 600, letterSpacing: 1, fontSize: 10 }}>
                                  🔑 CHAVE SEFAZ
                                </small>

                                {/* Loja — só quando há mais de 1 configurada */}
                                {!lojasNfeLoading && lojasNfe.length > 1 && (
                                  <ReactSelect
                                    placeholder="Selecione a loja..."
                                    options={lojasNfe}
                                    value={filialNfe}
                                    onChange={setFilialNfe}
                                    styles={{
                                      control: base => ({ ...base, minHeight: 34, fontSize: 13 }),
                                      valueContainer: base => ({ ...base, padding: '0 8px' }),
                                      input: base => ({ ...base, margin: 0, padding: 0 }),
                                    }}
                                  />
                                )}

                                <Input
                                  type="text"
                                  id="chave-nfe"
                                  name="chave-nfe"
                                  className="input-chave m-0"
                                  placeholder="Digite a chave de acesso (44 dígitos)"
                                  onChange={onChangeChaveNfe}
                                />
                              </div>
                            </Col>

                            {/* Botões — Baixar e Lançar empilhados */}
                            <Col md="2" className="d-flex flex-column" style={{ gap: 8 }}>
                              {!lojasNfeLoading && lojasNfe.length === 0 ? (
                                <Button
                                  type="button"
                                  className="w-100 m-0 flex-fill"
                                  color="warning"
                                  style={{ color: '#fff' }}
                                  title="Nenhuma loja com certificado configurado. Clique para configurar."
                                  onClick={(e) => { e.preventDefault(); window.location.href = '/painelwebgestor/admin/config-nfe'; }}
                                >
                                  <i className="fas fa-exclamation-triangle mr-1" />
                                  Config. NFe
                                </Button>
                              ) : (
                                <Button
                                  type="button"
                                  className="w-100 m-0 flex-fill"
                                  color="info"
                                  onClick={downloadXml}
                                  disabled={lojasNfeLoading || (lojasNfe.length > 1 && !filialNfe)}
                                >
                                  Baixar
                                </Button>
                              )}
                              <Button
                                type="button"
                                className="w-100 m-0 flex-fill"
                                color="success"
                                onClick={() => geraNovoXml()}
                                disabled={btDisabled || destinatario[0].cnpj === ''}
                              >
                                Lançar
                              </Button>
                            </Col>
                          </Row>

                          {/* ── Chave e número da nota (readonly) ───────────────── */}
                          <Row className="mt-2 align-items-center">
                            <Col>
                              <div className="card-2 mb-0" style={{ padding: '9px' }}>
                                <span className="tag-card-div">Chave</span>
                                <FormGroup className="mb-0">
                                  <Input
                                    type="text"
                                    name="chave"
                                    className="inputNone"
                                    disabled
                                    defaultValue={formulario.dadosNota._attributes ? formulario.dadosNota._attributes.Id : ''}
                                  />
                                </FormGroup>
                              </div>
                            </Col>
                            <Col md="2">
                              <div className="card-2 mb-0" style={{ padding: '9px' }}>
                                <span className="tag-card-div">Número</span>
                                <FormGroup className="mb-0">
                                  <Input
                                    type="text"
                                    name="nota"
                                    className="inputNone"
                                    disabled
                                    defaultValue={formulario.dadosNota.ide.nNF._text}
                                  />
                                </FormGroup>
                              </div>
                            </Col>
                          </Row>

                          {/* Forma de Pagamento — oculta, manter para reativar se necessário
                          <Row className="mt-2">
                            <Col md="4">
                              <div className="card-2 text-center mb-0" style={{ padding: '12px' }}>
                                <span className="tag-card-div">Forma de Pagamento</span>
                                <div className="form-check-radio form-check-inline mb-0">
                                  <Label className="form-check-label">
                                    <Input type="radio" name="forma-pag" id="forma-pag1" value="0" disabled={btDisabled} />
                                    A Vista <span className="form-check-sign"></span>
                                  </Label>
                                </div>
                                <div className="form-check-radio form-check-inline mb-0">
                                  <Label className="form-check-label">
                                    <Input type="radio" name="forma-pag" id="forma-pag2" value="1" disabled={btDisabled} />
                                    A Prazo <span className="form-check-sign"></span>
                                  </Label>
                                </div>
                                <div className="form-check-radio form-check-inline mb-0">
                                  <Label className="form-check-label">
                                    <Input type="radio" name="forma-pag" id="forma-pag3" value="2" disabled={btDisabled} />
                                    Outros <span className="form-check-sign"></span>
                                  </Label>
                                </div>
                              </div>
                            </Col>
                          </Row>
                          */}
                          {/* opções ocultadas — ajuste automático via calculaTotaisNota
                          <Row>
                            <Col className="mt-3">
                              <FormGroup check inline className="mb-0">
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    id="dividir-desconto"
                                    onChange={mudaDesconto}
                                    checked={formulario.dividir_desconto === 'S'}
                                  />
                                  <span className="form-check-sign" />Dividir desconto por quantidade nos itens
                                </Label>
                              </FormGroup>{" "}

                              <FormGroup check inline className="mb-0">
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    id="nao-incluir-st"
                                    onChange={mudaIncluirST}
                                    checked={formulario.nao_incluir_st === 'S'}
                                  />
                                  <span className="form-check-sign" />Não incluir ST no total da nota
                                </Label>
                              </FormGroup>{" "}

                            </Col>
                          </Row>
                          */}

                        </Container>
                      </Form>
                    </div>

                    {/* <span className="span-divider"></span>   */}


                    <Collapse toggler="#toggler" isOpen={isOpen}>
                      {/* <div className="dadosNFe border p-3"> */}
                      {/* <div className="card mb-0" style={{ padding: '9px' }}>
                                <span className="tag-card-div"></span> */}


                      <Row>

                        <Col md="12">
                          <div className="card-2 dadosNFe" style={{ padding: '9px' }}>
                            <span className="tag-card-div">Destinatário</span>
                            <Row>
                              <Col md="4">

                                <Label>Razão Social</Label>
                                <Input
                                  type="text"
                                  name="razao_social"
                                  disabled
                                  value={destinatario[0].razao_social}
                                />

                              </Col>

                              <Col md="4">

                                <Label>Fantasia</Label>
                                <Input
                                  type="text"
                                  name="fantasia"
                                  // className="inputNone"
                                  disabled
                                  value={destinatario[0].fantasia}
                                />

                              </Col>

                              <Col md="4">

                                <Label>CNPJ</Label>
                                <NumberFormat
                                  // valid
                                  className="form-control"
                                  format="##.###.###/####-##"
                                  name="cnpj"
                                  id="cnpj"
                                  value={destinatario[0].cnpj}
                                  disabled
                                />
                                {/* <Input
                                        type="text"
                                        name="cnpj"
                                        // className="inputNone"
                                        disabled
                                        defaultValue={destinatario[0].cnpj}
                                      /> */}

                              </Col>

                            </Row>
                          </div>
                        </Col>

                      </Row>
                    </Collapse>
                    {/* <span className="span-divider"></span>   */}


                    <Collapse toggler="#toggler" isOpen={isOpen}>
                      <div className="dadosNFe border p-3">

                        <Row className="mb-2">
                          <Col md="6">
                            <Label>Fornecedor</Label>
                            <Input
                              type="text"
                              name="fornecedor"
                              disabled
                              defaultValue={formulario.dadosNota.emit.xNome._text}
                            />
                          </Col>
                          <Col>
                            <Label>Data Emissão</Label>
                            <Input
                              type="text"
                              name="emissao"
                              disabled
                              //defaultValue={moment(Date.parse(formulario.dadosNota.dhEmi)).format('YYYY-MM-DD')}
                              defaultValue={formulario.dadosNota.ide.dhEmi ? moment(formulario.dadosNota.ide.dhEmi._text).format('DD/MM/YYYY') : ''}
                            />
                          </Col>
                          <Col>
                            <Label>Data Entrada</Label>
                            <Input
                              type="text"
                              name="entrada"
                              disabled
                              defaultValue={moment().format('DD/MM/YYYY')}
                            />
                          </Col>
                          <Col>
                            <Label>Série</Label>
                            <Input
                              type="text"
                              name="serie"
                              disabled
                              defaultValue={formulario.dadosNota.ide.serie._text}
                            />
                          </Col>
                          <Col>
                            <Label>Modelo</Label>
                            <Input
                              type="text"
                              name="modelo"
                              disabled
                              defaultValue={formulario.dadosNota.ide.mod._text}
                            />
                          </Col>
                        </Row>

                        <Row className="mb-2">
                          <Col>
                            <Label>Base ICMS</Label>
                            <Input
                              type="text"
                              name="base_icms"
                              disabled
                              value={toBRL(formulario.dadosNota.total.ICMSTot.vBC._text)}
                              onChange={() => {}}
                            />
                          </Col>
                          <Col>
                            <Label>Valor ICMS</Label>
                            <Input
                              type="text"
                              name="vlr_icms"
                              disabled
                              value={toBRL(formulario.dadosNota.total.ICMSTot.vICMS._text)}
                              onChange={() => {}}
                            />
                          </Col>
                          <Col>
                            <Label>Base ST</Label>
                            <Input
                              type="text"
                              name="base_st"
                              disabled
                              value={toBRL(formulario.dadosNota.total.ICMSTot.vBCST._text)}
                              onChange={() => {}}
                            />
                          </Col>
                          <Col>
                            <Label>Valor ST</Label>
                            <Input
                              type="text"
                              name="vlr_st"
                              disabled
                              value={toBRL(formulario.dadosNota.total.ICMSTot.vST._text)}
                              onChange={() => {}}
                            />
                          </Col>
                        </Row>

                        <Row className="mb-2">
                          <Col>
                            <Label>Frete</Label>
                            <Input
                              type="text"
                              name="frete"
                              disabled
                              value={toBRL(formulario.dadosNota.total.ICMSTot.vFrete._text)}
                              onChange={() => {}}
                            />
                          </Col>
                          <Col>
                            <Label>Seguro</Label>
                            <Input
                              type="text"
                              name="seguro"
                              disabled
                              value={toBRL(formulario.dadosNota.total.ICMSTot.vSeg._text)}
                              onChange={() => {}}
                            />
                          </Col>
                          <Col>
                            <Label>Outras</Label>
                            <Input
                              type="text"
                              name="outras"
                              disabled
                              value={toBRL(formulario.dadosNota.total.ICMSTot.vOutro._text)}
                              onChange={() => {}}
                            />
                          </Col>
                          <Col>
                            <Label>Desconto Especial</Label>
                            <Input
                              type="text"
                              name="desc_especial"
                              disabled
                              value={toBRL(formulario.dadosNota.total.ICMSTot.vDesc._text)}
                              onChange={() => {}}
                            />
                          </Col>
                          <Col>
                            <Label><b>Total Itens</b></Label>
                            <Input
                              type="text"
                              name="total_itens"
                              disabled
                              value={toBRL(formulario.dadosNota.total.ICMSTot.vProd._text)}
                              onChange={() => {}}
                            />
                          </Col>
                          <Col>
                            <Label><b>Total Nota</b></Label>
                            <Input
                              type="text"
                              name="total_nota"
                              disabled
                              value={toBRL(formulario.dadosNota.total.ICMSTot.vNF._text)}
                              onChange={() => {}}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Collapse>

                    {/* <span className="span-divider"></span>   */}

                    {
                      formulario.produtosNfe[0].det.prod.nitem != '' &&

                      <TableNfe
                        columns={colunasOrdenadas}
                        config={{
                          frozenColumns: true,
                          frozenColumnsCount: 6
                        }}
                        data={formulario.produtosNfe ? formulario.produtosNfe : []}
                        rowStyle={rowStyle2}
                        recalculaMargemMkp={recalculaMargemMkp}
                        setColumn={handleSetColumn}
                        gravaPosicaoColunas={handleSetColumn}
                        onTableChange={(type, data, rowId, dataField, newValue) => handleTableChange(type, data, rowId, dataField, newValue)}
                      ></TableNfe>

                      // <BootstrapTable
                      //   striped
                      //   expandRow={expandLotes}
                      //   trClassName="customClass"
                      //   remote
                      //   keyField='idx'
                      //   noDataIndication="Nenhum registro encontrado"
                      //   rowStyle={rowStyle2}
                      //   {...props.baseProps}
                      //   cellEdit={
                      //     cellEditFactory({
                      //       mode: 'dbclick',

                      //       afterSaveCell: (oldValue, newValue, row, column) => { console.log('after') }

                      //     })
                      //   }
                      //   onTableChange={(type, { data, cellEdit: { rowId, dataField, newValue } }) => handleTableChange(type, { data, cellEdit: { rowId, dataField, newValue } })}
                      // />
                    }
                  </div>


                  <div className="dadosNFe  p-3">
                    <Collapse toggler="#toggler" isOpen={isOpen}>
                      <div className="cobr-container">
                        <div className="cobr-title-row">
                          <span className="cobr-title-text">Cobrança</span>
                        </div>
                        <Row className="cobr-header-row">
                          <Col md="4" className="cobr-header-cell">Nº Documento</Col>
                          <Col md="4" className="cobr-header-cell">Vencimento</Col>
                          <Col md="3" className="cobr-header-cell">Valor</Col>
                          <Col
                            md="1"
                            className="cobr-header-cell d-flex justify-content-center align-items-center"
                            onClick={() => { setEditCobIdx(-1); setIsOpenModalCobranca(true) }}
                          >
                            <i className="fas fa-plus cobr-icon"></i>
                          </Col>
                        </Row>
                        {formulario.dadosNota && formulario.dadosNota.cobr && formulario.dadosNota.cobr.dup &&
                          Array.isArray(formulario.dadosNota.cobr.dup) &&
                          formulario.dadosNota.cobr.dup.map((dup, idx) =>
                            <Row key={idx} className="cobr-data-row">
                              <Col md="4" className="cobr-data-cell">
                                {formulario.dadosNota.cobr.fat.nFat._text}
                              </Col>
                              <Col md="4" className="cobr-data-cell">
                                {moment(dup.dVenc._text).format('DD/MM/YYYY')}
                              </Col>
                              <Col md="3" className="cobr-data-cell">
                                {toBRL(dup.vDup._text)}
                              </Col>
                              <Col
                                md="1"
                                className="cobr-data-cell d-flex justify-content-center align-items-center"
                                onClick={() => { setEditCobIdx(dup.idx); setIsOpenModalCobranca(true) }}
                              >
                                <i className="fa fa-pencil cobr-icon"></i>
                              </Col>
                            </Row>
                          )}
                      </div>
                    </Collapse>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Container fluid style={{ maxWidth: '95%' }}>
          {/* <Row>
            <Col md="12" className="p-0">
        <Card>
        <CardBody>          
            <div class="legend-grid">
              <div class="legend-item pr-venda" data-tooltip="O preço de venda atual é zero">
                <div class="legend-color color-pr-venda"></div>
                <span class="legend-text">Pr. Venda = R$ 0,00</span>
              </div>

              <div class="legend-item pr-matriz-menor" data-tooltip="O preço da matriz é inferior ao calculado">
                <div class="legend-color color-pr-matriz-menor"></div>
                <span class="legend-text">Pr. Matriz Menor</span>
              </div>

              <div class="legend-item pr-matriz-maior" data-tooltip="O preço da matriz é superior ao calculado">
                <div class="legend-color color-pr-matriz-maior"></div>
                <span class="legend-text">Pr. Matriz Maior</span>
              </div>

              <div class="legend-item produto-nao-cadastrado" data-tooltip="O produto ainda não foi cadastrado no sistema">
                <div class="legend-color color-produto-nao-cadastrado"></div>
                <span class="legend-text">Produto Não Cadastrado</span>
              </div>

              <div class="legend-item produto-inativo" data-tooltip="O produto está desativado no sistema">
                <div class="legend-color color-produto-inativo"></div>
                <span class="legend-text">Produto Inativo</span>
              </div>

              <div class="legend-item produto-cadastramento" data-tooltip="O produto está aguardando a integração para ser cadastrado">
                <div class="legend-color color-produto-cadastramento"></div>
                <span class="legend-text">Produto em Cadastramento</span>
            </div>
            </div>

            </CardBody>
            </Card>
            </Col>
          </Row> */}

            <Row>
              <Col md="12" className="p-0">
                <div style={{
                  background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                  border: '1px solid #dee2e6',
                  borderRadius: '12px',
                  padding: '10px 18px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.07)',
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '8px'
                }}>
                  <span style={{
                    fontSize: 10,
                    fontWeight: 700,
                    color: '#6c757d',
                    textTransform: 'uppercase',
                    letterSpacing: '0.8px',
                    marginRight: 6,
                    whiteSpace: 'nowrap'
                  }}>
                    <i className="fa fa-circle-info mr-1" style={{ color: '#adb5bd' }}></i>
                    Legenda:
                  </span>

                  {[
                    { color: '#FEBC98', border: '#e8915a', text: 'Pr. Venda = R$ 0,00' },
                    { color: '#ff8080', border: '#d94f4f', text: 'Pr. Matriz Menor que Pr. Atualizado' },
                    { color: '#C5EA69', border: '#8ab52e', text: 'Pr. Matriz Maior que Pr. Atualizado' },
                    { color: '#f44336', border: '#b71c1c', text: 'Produto Não Cadastrado' },
                    { color: '#ffcc80', border: '#e6972a', text: 'Produto Inativo' },
                    { color: '#90CAF9', border: '#1565C0', text: 'Aguardando Cadastramento' },
                  ].map((item, i) => (
                    <div key={i} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      background: item.color + '30',
                      border: `1px solid ${item.color}`,
                      borderRadius: '20px',
                      padding: '4px 10px',
                      whiteSpace: 'nowrap'
                    }}>
                      <div style={{
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        backgroundColor: item.color,
                        border: `2px solid ${item.border}`,
                        flexShrink: 0
                      }} />
                      <span style={{
                        fontSize: 10,
                        fontWeight: 500,
                        color: '#343a40'
                      }}>
                        {item.text}
                      </span>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
        </Container>

      </div>
    )
  }
}

export default EntradaNFe;